// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.paid-media-dashboard-with-data {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  width: 100%;
  height: 100%;
  max-height: 100%;
  overflow: hidden;
}

.paid-media-dashboard-with-data > * {
  flex: 1 1 auto;
  min-height: 0;
  min-width: 0;
  width: 100%;
}

.paid-media-tabs-dashboard {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  width: 100%;
  overflow: hidden;
}

.paid-media-tabs-dashboard__tabs {
  align-self: flex-start;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
  padding: 8px;
  border-radius: 20px;
  background: #eaf0f7;
  width: fit-content;
  max-width: 100%;
  flex-shrink: 0;
}

.paid-media-tabs-dashboard__tab {
  flex-shrink: 0;
  height: 38px;
  padding: 0 22px;
  border: 0;
  border-radius: 14px;
  background: transparent;
  color: #60718b;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
}

.paid-media-tabs-dashboard__tab--active {
  background: #ffffff;
  color: #0f172a;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.08);
}

.paid-media-tabs-dashboard__coming-soon {
  min-height: 320px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px dashed #cfd9e6;
  border-radius: 20px;
  background: #ffffff;
  color: #60718b;
  font-size: 15px;
  font-weight: 600;
}

.paid-media-tabs-dashboard__loading {
  min-height: 320px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.paid-media-dashboard {
  flex: 1 1 auto;
  min-height: 0;
  background: #ffffff;
  border-radius: 20px;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.paid-media-report {
  background: #ffffff;
  color: #0f172a;
}

.paid-media-toolbar {
  position: sticky;
  top: 0;
  z-index: 5;
  backdrop-filter: blur(10px);
  background: rgba(255, 255, 255, 0.92);
  border-bottom: 1px solid #e2e8f0;
}

/** Title + date row and filter row are grouped; border sits below filters. */
.paid-media-report__header-block {
  padding: 18px 18px 16px;
  margin-bottom: 16px;
  border-bottom: 1px solid #e4e7ec;
  background: #ffffff;
}

.paid-media-report__header-block .paid-media-report__section-header {
  padding: 0;
  margin: 0;
}

.paid-media-report__section-header {
  padding: 18px 18px 16px;
  margin-bottom: 16px;
}

/**
 * Second row: subtext left (grows), Campaigns / Platforms / Regions right — same baseline as the reference.
 * (No Clear control.)
 */
.paid-media-report__subtitle-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px 20px;
  margin-top: 6px;
  width: 100%;
}

.paid-media-report__header-subtitle {
  margin: 0;
  flex: 1 1 200px;
  min-width: min(100%, 200px);
  max-width: none;
}

.paid-media-report__filters-bar {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
  justify-content: flex-end;
  margin-top: 0;
  margin-inline-start: auto;
  flex: 0 0 auto;
  width: auto;
  max-width: 100%;
}

.paid-media-report__filters-bar .dashboard-section-header__control {
  min-width: 260px;
  max-width: 260px;
  flex: 0 0 auto;
}

.paid-media-report__title {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  color: #101828;
}

.paid-media-report__subtitle {
  margin: 0;
  color: #667085;
  font-size: 14px;
  line-height: 1.5;
}

.paid-media-toolbar__inner {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  padding: 12px 16px;
  overflow: visible;
}

.paid-media-filter-icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  color: #60718b;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.paid-media-filter-chip {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  height: 44px;
  width: 100%;
  padding: 0 16px;
  border: 1px solid #dde5ef;
  border-radius: 8px;
  background: #ffffff;
  flex-shrink: 0;
  overflow: hidden;
  color: #0f172a;
}

.paid-media-filter-chip input {
  border: 0;
  background: transparent;
  color: #0f172a;
  font-size: 13px;
  outline: none;
}

.paid-media-toolbar__date-range {
  flex-shrink: 0;
}

.paid-media-filter-chip:not(.paid-media-filter-chip--date) {
  min-width: 0;
  max-width: none;
}

.paid-media-filter-dropdown {
  position: relative;
  flex-shrink: 0;
  min-width: 0;
  z-index: 30;
}

.paid-media-filter-dropdown__trigger {
  width: 100%;
  justify-content: space-between;
  padding-inline-end: 38px;
  cursor: pointer;
  overflow: hidden;
}

.paid-media-filter-dropdown__label {
  display: inline-block;
  min-width: 0;
  max-width: calc(100% - 30px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.paid-media-filter-dropdown__menu {
  position: absolute;
  top: calc(100% + 8px);
  inset-inline-start: 0;
  min-width: 260px;
  max-width: 420px;
  width: max-content;
  padding: 6px;
  border: 1px solid #e6edf7;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
  z-index: 20;
}

.paid-media-filter-dropdown__item {
  width: 100%;
  display: grid;
  grid-template-columns: 20px minmax(0, 1fr);
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #0f172a;
  font-size: 13px;
  text-align: start;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease;
  min-width: 0;
}

.paid-media-filter-dropdown__item span:last-child {
  display: block;
  min-width: 0;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.paid-media-filter-dropdown__item:hover {
  background: #f2f2f2;
}

.paid-media-filter-dropdown__item--selected {
  background: #e4e4e4;
  color: #1f1f1f;
  font-weight: 600;
}

.paid-media-filter-dropdown__check {
  width: 16px;
  height: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #0f172a;
}

.paid-media-filter-chip__chevron {
  position: absolute;
  inset-inline-end: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: #7b8aa0;
  pointer-events: none;
}

.paid-media-report__content {
  padding: 10px 18px 18px;
}

.paid-media-report__content .dashboard-narrative-panel {
  margin-bottom: 16px;
}

.paid-media-report__loading {
  min-height: 320px;
}

.paid-media-kpi-grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 14px;
  margin-bottom: 14px;
}

.paid-media-kpi-card,
.paid-media-panel,
.paid-media-table-panel,
.dashboard-data-table-panel,
.paid-media-empty-state,
.paid-media-empty-section,
.paid-media-tabs-bar {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04), 0 4px 12px rgba(15, 23, 42, 0.03);
}

/* KPI tiles use global DashboardKpiCard (flex column: title + ?, value, period; icon top-right). */
.paid-media-kpi-card {
  padding: 18px;
  transition: box-shadow 0.2s ease;
  display: flex !important;
  flex-direction: column;
  gap: 12px;
  min-height: 0;
  position: relative;
  overflow: visible;
}

.paid-media-kpi-card:hover {
  box-shadow: 0 16px 30px rgba(15, 23, 42, 0.08);
  z-index: 20;
}

.paid-media-kpi-card.dashboard-kpi-card .dashboard-kpi-card__header {
  margin-top: 0;
}

.paid-media-kpi-card.dashboard-kpi-card .dashboard-kpi-card__title-row {
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  gap: 5px;
  width: 100%;
  max-width: 100%;
}

.paid-media-kpi-card.dashboard-kpi-card .dashboard-kpi-card__title-row .definition-tooltip {
  align-self: flex-start;
  margin-top: -1px;
}

.paid-media-kpi-card.dashboard-kpi-card .dashboard-kpi-card__title-row .definition-tooltip__trigger {
  transform: none;
}

.paid-media-kpi-card.dashboard-kpi-card .dashboard-kpi-card__title {
  flex: 0 1 auto;
  font-size: 10px;
  line-height: 1.35;
  letter-spacing: 0.08em;
  max-width: min(100%, 180px);
  white-space: nowrap;
  display: block;
  -webkit-line-clamp: unset;
  -webkit-box-orient: unset;
  line-clamp: unset;
  max-height: none;
  text-overflow: ellipsis;
}

.paid-media-kpi-card--long-title.dashboard-kpi-card .dashboard-kpi-card__title {
  white-space: normal;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  line-clamp: 2;
  max-height: 2.7em;
  text-overflow: clip;
}

.paid-media-kpi-card.dashboard-kpi-card .dashboard-kpi-card__value {
  white-space: normal;
  word-break: normal;
  overflow-wrap: normal;
  font-size: clamp(18px, 1.45vw, 24px);
  line-height: 1.2;
}

.paid-media-kpi-card.dashboard-kpi-card .dashboard-kpi-card__period {
  font-size: 12px;
}

.paid-media-kpi-card.dashboard-kpi-card .dashboard-kpi-card__change--positive {
  color: #15803d;
}

.paid-media-kpi-card.dashboard-kpi-card .dashboard-kpi-card__change--negative {
  color: #b91c1c;
}

.paid-media-kpi-card .recharts-tooltip-wrapper,
.paid-media-panel .recharts-tooltip-wrapper {
  z-index: 1000;
}

.paid-media-overview-grid,
.paid-media-campaigns-grid {
  display: grid;
  grid-template-columns: minmax(0, 2.1fr) minmax(320px, 1fr);
  gap: 16px;
  margin-bottom: 14px;
}

/* When only one chart remains (e.g. Meta Ads campaigns), span full row width */
.paid-media-campaigns-grid > .paid-media-panel:only-child {
  grid-column: 1/-1;
}

.paid-media-panel {
  padding: 20px 20px;
  margin-bottom: 20px;
}

.paid-media-panel--wide,
.paid-media-panel--trend {
  min-width: 0;
}

.paid-media-panel__header,
.paid-media-table-panel__header {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: center;
  margin-bottom: 16px;
}

.paid-media-panel__header h3,
.paid-media-table-panel__header h3 {
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 10px;
}

.paid-media-panel__heading {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}

.paid-media-panel__heading h3 {
  margin-bottom: 0;
  line-height: 1.2;
}

.paid-media-chart {
  height: 240px;
  position: relative;
  overflow: visible;
}

.paid-media-chart--trend {
  height: 300px;
}

.paid-media-chart--pie {
  height: 220px;
}

.paid-media-chart--compact {
  height: 260px;
}

.paid-media-chart--ads {
  height: 230px;
}

.paid-media-panel__header-actions {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
  width: 100%;
}

.paid-media-panel__header--trend {
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 16px;
}

.paid-media-panel__header-actions--trend {
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: flex-end;
  justify-content: flex-end;
  gap: 10px;
  margin-inline-start: auto;
  min-width: min(100%, 360px);
}

.paid-media-panel__header--with-legend {
  flex-wrap: wrap;
  align-items: center;
}

.paid-media-chart-legend {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px;
  margin-inline-start: auto;
  list-style: none;
  margin-block: 0;
  padding-inline-start: 0;
}

.paid-media-chart-legend__item {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  color: #64748b;
  font-size: 11px;
  font-weight: 700;
}

.paid-media-chart-legend__swatch {
  width: 12px;
  height: 12px;
  border-radius: 3px;
  flex-shrink: 0;
}

.paid-media-visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.paid-media-trend-granularity {
  display: inline-flex;
  padding: 2px;
  border-radius: 8px;
  background: #edf3fb;
  gap: 2px;
  align-self: flex-end;
  border: 0;
  margin: 0;
  min-width: 0;
}

.paid-media-trend-granularity__btn {
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: #64748b;
  font-size: 10px;
  font-weight: 700;
  line-height: 1;
  min-width: 48px;
  height: 28px;
  padding: 0 12px;
  cursor: pointer;
}

.paid-media-trend-granularity__btn--active {
  background: #ffffff;
  color: #000000;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08);
}

.paid-media-trend-chips {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
}

.paid-media-trend-chips__item {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  height: 28px;
  min-width: 78px;
  padding: 0 12px;
  border: 1px solid #dce3ed;
  border-radius: 999px;
  background: #ffffff;
  color: #64748b;
  font-size: 10px;
  font-weight: 600;
  cursor: pointer;
}

.paid-media-trend-chips__item--active {
  background: #EEF4FF;
  color: #6B7280;
  border-color: none;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08);
}

.paid-media-trend-chips__dot {
  width: 7px;
  height: 7px;
  border-radius: 999px;
}

.paid-media-trend-chips--legend .paid-media-trend-chips__item {
  cursor: pointer;
}

fieldset.paid-media-trend-chips--legend {
  border: 0;
  margin: 0;
  padding: 0;
  min-width: 0;
}

.paid-media-trend-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 10px;
}

.paid-media-trend-pagination__label {
  color: #7b8797;
  font-size: 13px;
  font-weight: 500;
}

.paid-media-trend-pagination__nav {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.paid-media-trend-pagination__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: 1px solid #dce3ed;
  border-radius: 7px;
  background: #ffffff;
  color: #64748b;
  cursor: pointer;
  transition: background 0.16s ease, border-color 0.16s ease, color 0.16s ease;
}

.paid-media-trend-pagination__btn:hover:not(:disabled) {
  background: #f8fafc;
  border-color: #cbd5e1;
  color: #334155;
}

.paid-media-trend-pagination__btn:disabled {
  color: #cbd5e1;
  cursor: not-allowed;
  opacity: 0.8;
}

.paid-media-funnel {
  display: grid;
  gap: 16px;
}

.paid-media-funnel__drop {
  margin-bottom: 6px;
  color: #dc2626;
  font-size: 11px;
  font-weight: 700;
}

.paid-media-funnel__meta {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 6px;
  color: #475569;
  font-size: 12px;
}

.paid-media-funnel__meta strong {
  color: #0f172a;
}

.paid-media-funnel__track {
  height: 48px;
  padding: 5px;
  border-radius: 12px;
  background: #eef2f7;
}

.paid-media-funnel__fill {
  height: 100%;
  border-radius: 10px;
}

.paid-media-list {
  display: grid;
  gap: 12px;
}

.paid-media-list__item {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px;
  padding: 12px 0;
  border-bottom: 1px solid #eef2f7;
}

.paid-media-list__item:last-child {
  border-bottom: 0;
}

.paid-media-list__icon {
  width: 42px;
  height: 42px;
  border-radius: 14px;
  background: #eff6ff;
  color: #2563eb;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.paid-media-list__content {
  display: grid;
  gap: 3px;
  min-width: 0;
}

.paid-media-list__content strong {
  font-size: 13px;
  color: #0f172a;
}

.paid-media-list__content span {
  color: #64748b;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.paid-media-list__value {
  display: grid;
  justify-items: end;
  gap: 2px;
}

.paid-media-list__value span {
  font-size: 16px;
  font-weight: 700;
  color: #16a34a;
}

.paid-media-list__value small {
  color: #64748b;
  font-size: 11px;
}

.paid-media-creative {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  align-items: flex-start;
  gap: 10px;
}

.paid-media-creative--inline {
  gap: 12px;
}

.paid-media-creative__thumb {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: #f3f6fa;
  color: #94a3b8;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.85);
}

.paid-media-creative__thumb span {
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.paid-media-creative strong {
  display: block;
  margin-bottom: 4px;
  font-size: 12px;
  font-weight: 600;
  text-align: start;
}

.paid-media-creative__title-inline {
  display: inline-flex !important;
  align-items: center;
  gap: 8px;
  margin-bottom: 0 !important;
  min-width: 0;
  white-space: normal;
  word-break: normal;
  overflow-wrap: anywhere;
}

.paid-media-creative span {
  color: #000;
  font-size: 10px;
}

.paid-media-tag-row {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 4px;
  min-width: 0;
  width: 100%;
  align-items: flex-start;
}

.paid-media-tag-row .paid-media-mini-tag {
  max-width: min(100%, 320px);
  white-space: normal;
  word-break: normal;
  overflow-wrap: anywhere;
  height: auto;
  min-height: 21px;
  padding-top: 2px;
  padding-bottom: 2px;
  line-height: 1.2;
}

.paid-media-report__ad-col {
  min-width: 340px;
  width: 1%;
}

.paid-media-report__ad-id-col {
  min-width: 120px;
  white-space: nowrap;
}

.paid-media-table-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  min-width: auto;
}

.paid-media-table-toolbar__filters {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 12px;
  min-width: 0;
}

.paid-media-table-toolbar__filter {
  min-width: 220px;
  max-width: 320px;
  flex: 0 1 280px;
}

.paid-media-table-toolbar__filter .paid-media-filter-dropdown {
  width: 100%;
}

.paid-media-table-toolbar__search {
  min-width: 260px;
  width: min(100%, 360px);
  margin-inline-start: auto;
}

.google-ads-report__ad-id-col {
  min-width: 260px;
  width: auto;
}

.google-ads-report__ad-id-col .paid-media-mini-tag {
  display: inline-flex;
  max-width: 100%;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
}

.paid-media-mini-tag,
.paid-media-status-chip {
  display: inline-flex;
  align-items: center;
  height: 21px;
  padding: 0 7px;
  border: 1px solid #cfd9e6;
  border-radius: 6px;
  background: #ffffff;
  color: #5f7696;
  font-size: 9px;
  font-weight: 700;
  white-space: nowrap;
}

.paid-media-mini-tag--platform {
  height: 23px;
  padding: 0 12px;
  font-size: 10px;
  color: #0f172a;
}

/* Meta platform & Google network “channel” colors */
.paid-media-mini-tag--channel-instagram {
  background: rgba(168, 85, 247, 0.16);
  border-color: #a855f7;
  color: #6b21a8;
}

.paid-media-mini-tag--channel-facebook {
  background: rgba(24, 119, 242, 0.14);
  border-color: #1877f2;
  color: #0c4a8c;
}

.paid-media-mini-tag--channel-audience-network {
  background: rgba(14, 165, 233, 0.14);
  border-color: #0ea5e9;
  color: #0369a1;
}

.paid-media-mini-tag--channel-messenger {
  background: rgba(0, 132, 255, 0.14);
  border-color: #0084ff;
  color: #075985;
}

.paid-media-mini-tag--channel-threads {
  background: rgba(15, 23, 42, 0.08);
  border-color: #334155;
  color: #0f172a;
}

.paid-media-mini-tag--channel-default {
  background: rgba(100, 116, 139, 0.1);
  border-color: #94a3b8;
  color: #334155;
}

/* Google Ads network types */
.paid-media-mini-tag--channel-g-search {
  background: rgba(43, 116, 228, 0.14);
  border-color: #2b74e4;
  color: #1e3a8a;
}

.paid-media-mini-tag--channel-g-search-partners {
  background: rgba(59, 130, 246, 0.12);
  border-color: #3b82f6;
  color: #1e40af;
}

.paid-media-mini-tag--channel-g-pmax {
  background: rgba(234, 88, 12, 0.12);
  border-color: #ea580c;
  color: #9a3412;
}

.paid-media-mini-tag--channel-g-shopping {
  background: rgba(22, 163, 74, 0.12);
  border-color: #16a34a;
  color: #14532d;
}

.paid-media-mini-tag--channel-g-discover {
  background: rgba(217, 70, 239, 0.12);
  border-color: #d946ef;
  color: #86198f;
}

.paid-media-mini-tag--channel-g-gmail {
  background: rgba(220, 38, 38, 0.1);
  border-color: #dc2626;
  color: #991b1b;
}

.paid-media-mini-tag--channel-g-youtube {
  background: rgba(239, 68, 68, 0.12);
  border-color: #ef4444;
  color: #b91c1c;
}

.paid-media-mini-tag--channel-g-content {
  background: rgba(99, 102, 241, 0.12);
  border-color: #6366f1;
  color: #3730a3;
}

.paid-media-mini-tag--channel-g-display {
  background: rgba(20, 184, 166, 0.12);
  border-color: #14b8a6;
  color: #0f766e;
}

.paid-media-mini-tag--channel-g-smart {
  background: rgba(245, 158, 11, 0.14);
  border-color: #f59e0b;
  color: #b45309;
}

.paid-media-mini-tag--channel-g-local {
  background: rgba(37, 99, 235, 0.12);
  border-color: #2563eb;
  color: #1e3a8a;
}

.paid-media-mini-tag--channel-g-app {
  background: rgba(124, 58, 237, 0.12);
  border-color: #7c3aed;
  color: #5b21b6;
}

.paid-media-mini-tag--channel-g-other {
  background: rgba(71, 85, 105, 0.1);
  border-color: #64748b;
  color: #334155;
}

/* Campaign vs ad set / ad group row semantics */
.paid-media-mini-tag--role-campaign {
  background: rgba(245, 158, 11, 0.16);
  border-color: #f59e0b;
  color: #b45309;
}

.paid-media-mini-tag--role-adset {
  background: rgba(13, 148, 136, 0.14);
  border-color: #14b8a6;
  color: #0f766e;
}

/* Meta post / creative type */
.paid-media-mini-tag--meta-post-type {
  background: rgba(99, 102, 241, 0.12);
  border-color: #818cf8;
  color: #4338ca;
}

.paid-media-inline-badge {
  display: inline-flex;
  align-items: center;
  height: 20px;
  padding: 0 8px;
  border: 1px solid #d8e1ec;
  border-radius: 999px;
  color: #0f172a;
  font-size: 10px;
  font-weight: 700;
  text-transform: lowercase;
}

.paid-media-spark-trend {
  width: 88px;
  height: 28px;
}

.paid-media-status-chip--active {
  background: #2b74e4;
  border-color: #2b74e4;
  color: #ffffff;
}

.paid-media-status-chip--paused,
.paid-media-status-chip--learning {
  background: #ffffff;
  color: #0f172a;
}

.paid-media-status {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  text-transform: capitalize;
}

.paid-media-status--active {
  background: rgba(22, 163, 74, 0.12);
  color: #15803d;
}

.paid-media-status--learning {
  background: rgba(245, 158, 11, 0.12);
  color: #b45309;
}

.paid-media-status--paused {
  background: rgba(100, 116, 139, 0.12);
  color: #475569;
}

.paid-media-empty-state {
  padding: 36px 24px;
  text-align: center;
  color: #64748b;
  font-size: 14px;
}

.paid-media-meta-charts {
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-top: 4px;
  margin-bottom: 24px;
}

.paid-media-meta-charts .paid-media-panel--chart-stack {
  width: 100%;
  margin-bottom: 0;
}

.paid-media-chart--roas-stack {
  height: 250px;
  min-height: 250px;
}

.paid-media-meta-charts .paid-media-panel--chart-stack .paid-media-chart--grouped {
  height: 300px;
  min-height: 300px;
}

.paid-media-meta-charts .paid-media-panel--chart-stack .paid-media-chart--post-type {
  height: 280px;
  min-height: 280px;
}

/* Google Ads 2-row chart grid */
.paid-media-google-charts-row1 {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
  margin-bottom: 16px;
}

.paid-media-google-charts-row2 {
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(0, 1fr);
  gap: 16px;
  margin-bottom: 24px;
}

.paid-media-google-charts-row2--stacked {
  grid-template-columns: 1fr;
}

.paid-media-google-charts-row1 .paid-media-panel--chart-stack,
.paid-media-google-charts-row2 .paid-media-panel--chart-stack {
  width: 100%;
  margin-bottom: 0;
}

.paid-media-google-charts-row1 .paid-media-chart--roas-stack,
.paid-media-google-charts-row1 .paid-media-chart--grouped {
  height: 260px;
  min-height: 260px;
}

.paid-media-google-charts-row2 .paid-media-chart--post-type {
  height: 280px;
  min-height: 280px;
}

.paid-media-google-charts-row2 .paid-media-chart--roas-stack {
  height: 300px;
  min-height: 300px;
}

.paid-media-spend-distribution-body {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.paid-media-spend-distribution-body--wide {
  display: grid;
  grid-template-columns: minmax(260px, 320px) minmax(0, 1fr);
  gap: 16px 24px;
  align-items: center;
}

.paid-media-spend-distribution-body--wide .paid-media-chart--roas-stack {
  height: 300px;
  min-height: 300px;
  width: 100%;
}

.paid-media-pie-legend {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0 8px 8px;
  margin-top: 8px;
}

.paid-media-spend-distribution-body--wide .paid-media-pie-legend {
  margin-top: 0;
  padding: 0;
}

.paid-media-pie-legend--two-columns {
  display: block;
  column-count: 2;
  column-gap: 24px;
}

.paid-media-pie-legend--two-columns .paid-media-pie-legend__item {
  page-break-inside: avoid;
  break-inside: avoid;
  margin-bottom: 8px;
}

.paid-media-pie-legend--two-columns .paid-media-pie-legend__item:last-child {
  margin-bottom: 0;
}

.paid-media-pie-legend__item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #344054;
  min-width: 0;
}

.paid-media-pie-legend__swatch {
  flex-shrink: 0;
  width: 10px;
  height: 10px;
  border-radius: 2px;
}

.paid-media-pie-legend__name {
  flex: 1 1 auto;
  font-weight: 500;
  color: #344054;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.paid-media-pie-legend__value {
  flex-shrink: 0;
  font-weight: 600;
  color: #000;
  white-space: nowrap;
}

.paid-media-pie-legend__pct {
  margin-inline-start: 4px;
  font-weight: 400;
  color: #60718b;
}

@media (max-width: 1100px) {
  .paid-media-google-charts-row1 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .paid-media-google-charts-row2 {
    grid-template-columns: 1fr;
  }
  .paid-media-spend-distribution-body--wide {
    grid-template-columns: 1fr;
  }
  .paid-media-pie-legend--two-columns {
    column-count: 1;
  }
}
@media (max-width: 700px) {
  .paid-media-google-charts-row1 {
    grid-template-columns: 1fr;
  }
}
.paid-media-panel--chart-stack {
  padding: 18px 18px 14px;
}

.paid-media-panel--chart-stack .paid-media-panel__header {
  margin-bottom: 10px;
}

.paid-media-panel--chart-stack .recharts-responsive-container {
  overflow: visible;
}

.paid-media-panel--chart-stack .recharts-cartesian-axis-tick text {
  font-family: "opensans", sans-serif;
  font-weight: 500;
}

/**
 * Recharts places ticks, bars and labels with absolute SVG coordinates and \`text-anchor\`, which
 * resolve against the inline base direction — inheriting \`dir="rtl"\` flips the anchoring under
 * geometry computed for LTR, so Arabic axis labels overlap their own bars and clip at the panel
 * edge. The surface stays LTR and the layout is mirrored through props instead (see
 * \`usePaidMediaChartRtl\`). Scoped to the surface: \`.recharts-tooltip-wrapper\` is a sibling div
 * that must keep the page direction so its Arabic text reads right-to-left.
 */
.paid-media-chart .recharts-surface {
  direction: ltr;
}

.paid-media-table-zone {
  display: flex;
  flex-direction: column;
  gap: 18px;
  margin-top: 0;
  border: 0;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
  overflow: visible;
}

.paid-media-tabs-bar--attached {
  margin-top: 0;
  margin-bottom: 0;
  padding: 6px;
  border: 1px solid #e6edf5;
  border-radius: 8px;
  background: #eef2f7;
  box-shadow: none;
}

.paid-media-table-panel--attached.dashboard-data-table-panel,
.paid-media-table-panel--attached {
  margin-top: 0;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04), 0 4px 12px rgba(15, 23, 42, 0.03);
  background: #ffffff;
}

.paid-media-report .dashboard-data-table-panel__header {
  min-height: 76px;
  padding: 20px 20px;
  gap: 16px;
}

.paid-media-report .dashboard-data-table-panel__header h3 {
  font-size: 16px;
  line-height: 1.25;
}

.paid-media-report .dashboard-data-table-panel__search {
  min-width: 274px;
  height: 45px;
  padding: 0 12px;
  margin-bottom: 0;
}

.paid-media-report .dashboard-data-table-panel__search input {
  font-size: 13px;
  padding-inline-start: 8px;
}

.paid-media-report .dashboard-data-table th {
  padding: 17px 20px;
  color: #9aa6b5;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
}

.paid-media-table-panel__heading-block {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.paid-media-table-panel__subtitle {
  margin: 0;
  font-size: 12px;
  font-weight: 500;
  color: #64748b;
}

.paid-media-table__entity-link {
  color: #2563eb;
  font-weight: 600;
  font-size: 13px;
}

.paid-media-campaign-table-panel.dashboard-data-table-panel {
  border-color: #e2e8f0;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 2px 8px rgba(15, 23, 42, 0.04);
}

.paid-media-campaign-table-panel .dashboard-data-table-panel__header {
  min-height: 84px;
  padding: 22px 24px;
  border-bottom: 1px solid #e5eaf1;
}

.paid-media-campaign-table-panel .paid-media-panel__heading h3 {
  margin-bottom: 0;
  color: #344054;
  font-size: 20px;
  font-weight: 700;
  line-height: 1.2;
}

.paid-media-campaign-table-panel .paid-media-table-toolbar {
  align-items: center;
  flex: 0 1 auto;
  gap: 14px;
}

.paid-media-campaign-table-panel .paid-media-table-toolbar__search {
  display: inline-flex;
  align-items: center;
  width: 320px;
  min-width: 320px;
  height: 45px;
  margin: 0;
  border-color: #d6dde8;
  border-radius: 8px;
  color: #7a8797;
}

.paid-media-campaign-table-panel .paid-media-table-toolbar__search input {
  color: #344054;
  font-size: 14px;
}

.paid-media-campaign-table-panel .paid-media-table-toolbar__search input::placeholder {
  color: #8a96a8;
}

.paid-media-campaign-table-panel .paid-media-export-btn {
  align-self: center;
  height: 45px;
  margin: 0;
  padding: 0 16px;
  border-color: #d6dde8;
  color: #536174;
  font-size: 14px;
  font-weight: 700;
}

.paid-media-campaign-performance-table.dashboard-data-table {
  min-width: 1120px;
}

.paid-media-campaign-performance-table.dashboard-data-table thead th {
  padding: 18px 24px;
  background: #ffffff;
  border-bottom: 1px solid #eef2f7;
  color: #a3adbd;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0;
  text-transform: uppercase;
}

.paid-media-campaign-performance-table.dashboard-data-table thead th .dashboard-data-table__sort {
  text-transform: uppercase;
}

.paid-media-campaign-performance-table.dashboard-data-table tbody td {
  height: 72px;
  padding: 18px 24px;
  border-top: 1px solid #eef2f7;
  color: #667085;
  font-size: 13px;
  font-weight: 600;
}

.paid-media-campaign-performance-table.dashboard-data-table tbody tr:hover td {
  background: #ffffff;
}

.paid-media-campaign-performance-table.dashboard-data-table tbody tr.paid-media-table-subrow td {
  height: 72px;
  background-color: #f3f4f6 !important;
  border-top-color: #eef2f7;
}

.paid-media-campaign-performance-table.dashboard-data-table tbody tr.paid-media-table-subrow:hover td {
  background-color: #f3f4f6 !important;
}

.paid-media-campaign-performance-table .paid-media-campaign-cell {
  min-width: 238px;
  gap: 6px;
}

.paid-media-campaign-performance-table .paid-media-campaign-cell strong {
  margin-bottom: 3px;
  color: #536174;
  font-size: 13px;
  font-weight: 800;
}

.paid-media-campaign-performance-table .paid-media-campaign-expand {
  width: 16px;
  height: 18px;
  margin-top: 0;
  color: #a3adbd;
}

.paid-media-campaign-performance-table .paid-media-campaign-expand svg {
  width: 14px;
  height: 14px;
  stroke-width: 2.3;
}

.paid-media-campaign-performance-table .paid-media-mini-tag--muted {
  margin-top: 0;
  padding: 3px 8px;
  border: 1px solid #F3F4F6;
  border-radius: 4px;
  background: #F9FAFB;
  color: #9CA3AF;
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
}

.paid-media-campaign-performance-table .paid-media-table-subrow__label {
  display: grid;
  gap: 3px;
  padding-inline-start: 38px;
  color: #536174;
  font-size: 13px;
  font-weight: 800;
}

.paid-media-campaign-performance-table .paid-media-table-subrow__eyebrow {
  color: #9CA3AF;
  font-size: 13px;
  font-weight: 800;
}

.paid-media-campaign-performance-table td.paid-media-table__metric--success {
  color: #20bf6b;
  font-weight: 800;
}

.paid-media-campaign-table-panel .table-page-pagination {
  min-height: 64px;
  padding: 18px 24px;
  border-top: 1px solid #e5eaf1;
  background: #ffffff;
}

.paid-media-campaign-table-panel .table-page-pagination__label {
  color: #7b8797;
  font-size: 13px;
  font-weight: 700;
}

.paid-media-campaign-table-panel .table-page-pagination__btn {
  width: 32px;
  height: 32px;
  border-color: #e0e6ef;
  border-radius: 7px;
  background: #ffffff;
  color: #98a2b3;
}

.paid-media-adsets-table-panel.dashboard-data-table-panel {
  border-color: #e2e8f0;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 2px 8px rgba(15, 23, 42, 0.04);
}

.paid-media-adsets-table-panel .dashboard-data-table-panel__header {
  min-height: 86px;
  padding: 22px 24px;
  border-bottom: 1px solid #e5eaf1;
}

.paid-media-adsets-table-panel .paid-media-table-panel__heading-block {
  gap: 8px;
}

.paid-media-adsets-table-panel .paid-media-panel__heading h3 {
  margin-bottom: 0;
  color: #1f2937;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.2;
}

.paid-media-adsets-table-panel .paid-media-table-panel__subtitle {
  color: #667085;
  font-size: 13px;
  font-weight: 500;
}

.paid-media-adsets-table-panel .paid-media-table-toolbar {
  align-items: center;
  flex: 0 1 auto;
  gap: 14px;
}

.paid-media-adsets-table-panel .paid-media-table-toolbar__search {
  display: inline-flex;
  align-items: center;
  width: 300px;
  min-width: 300px;
  height: 45px;
  margin: 0;
  border-color: #d6dde8;
  border-radius: 8px;
  color: #7a8797;
}

.paid-media-adsets-table-panel .paid-media-table-toolbar__search input {
  color: #344054;
  font-size: 14px;
}

.paid-media-adsets-table-panel .paid-media-table-toolbar__search input::placeholder {
  color: #8a96a8;
}

.paid-media-adsets-table-panel .paid-media-export-btn {
  align-self: center;
  height: 45px;
  margin: 0;
  padding: 0 16px;
  border-color: #d6dde8;
  color: #536174;
  font-size: 14px;
  font-weight: 700;
}

.paid-media-adsets-performance-table.dashboard-data-table {
  min-width: 1000px;
}

.paid-media-adsets-performance-table.dashboard-data-table thead th {
  padding: 18px 24px;
  background: #ffffff;
  border-bottom: 1px solid #eef2f7;
  color: #a3adbd;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0;
  text-transform: uppercase;
}

.paid-media-adsets-performance-table.dashboard-data-table thead th .dashboard-data-table__sort {
  text-transform: uppercase;
}

.paid-media-adsets-performance-table.dashboard-data-table tbody td {
  height: 64px;
  padding: 18px 24px;
  border-top: 1px solid #eef2f7;
  color: #344054;
  font-size: 13px;
  font-weight: 500;
}

.paid-media-adsets-performance-table.dashboard-data-table tbody tr:hover td {
  background: #ffffff;
}

.paid-media-adsets-performance-table .paid-media-table__entity-link {
  color: #1f2937;
  font-size: 13px;
  font-weight: 500;
}

.paid-media-adsets-performance-table td.paid-media-table__metric--success {
  color: #009e4f;
  font-weight: 800;
}

.paid-media-adsets-table-panel .table-page-pagination {
  min-height: 64px;
  padding: 18px 24px;
  border-top: 1px solid #e5eaf1;
  background: #ffffff;
}

.paid-media-adsets-table-panel .table-page-pagination__label {
  color: #7b8797;
  font-size: 13px;
  font-weight: 700;
}

.paid-media-adsets-table-panel .table-page-pagination__btn {
  width: 32px;
  height: 32px;
  border-color: #e0e6ef;
  border-radius: 7px;
  background: #ffffff;
  color: #98a2b3;
}

.paid-media-ads-table-panel.dashboard-data-table-panel {
  border-color: #e2e8f0;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 2px 8px rgba(15, 23, 42, 0.04);
}

.paid-media-ads-table-panel .dashboard-data-table-panel__header {
  min-height: 86px;
  padding: 22px 24px;
  border-bottom: 1px solid #e5eaf1;
}

.paid-media-ads-table-panel .paid-media-table-panel__heading-block {
  gap: 8px;
}

.paid-media-ads-table-panel .paid-media-panel__heading h3 {
  margin-bottom: 0;
  color: #1f2937;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.2;
}

.paid-media-ads-table-panel .paid-media-table-panel__subtitle {
  color: #667085;
  font-size: 13px;
  font-weight: 500;
}

.paid-media-ads-table-panel .paid-media-table-toolbar {
  align-items: center;
  flex: 0 1 auto;
  gap: 14px;
}

.paid-media-table-panel--attached .paid-media-table-toolbar__filters,
.paid-media-table-panel--attached .paid-media-table-toolbar__filter {
  min-width: 0;
}

.paid-media-table-panel--attached .paid-media-table-toolbar__filters .paid-media-filter-dropdown {
  width: 150px;
}

.paid-media-table-panel--attached .paid-media-filter-dropdown__trigger {
  height: 45px;
  padding-inline-start: 14px;
  padding-inline-end: 34px;
  border-color: #d6dde8;
  border-radius: 8px;
  color: #344054;
  font-size: 13px;
  font-weight: 500;
}

.paid-media-table-panel--attached .paid-media-filter-dropdown__label {
  color: #344054;
}

.paid-media-ads-table-panel .paid-media-table-toolbar__search {
  display: inline-flex;
  align-items: center;
  width: 300px;
  min-width: 300px;
  height: 45px;
  margin: 0;
  border-color: #d6dde8;
  border-radius: 8px;
  color: #7a8797;
}

.paid-media-ads-table-panel .paid-media-table-toolbar__search input {
  color: #344054;
  font-size: 14px;
}

.paid-media-ads-table-panel .paid-media-table-toolbar__search input::placeholder {
  color: #8a96a8;
}

.paid-media-ads-table-panel .paid-media-export-btn {
  align-self: center;
  height: 45px;
  margin: 0;
  padding: 0 16px;
  border-color: #d6dde8;
  color: #536174;
  font-size: 14px;
  font-weight: 700;
}

.paid-media-ads-performance-table.dashboard-data-table {
  min-width: 1060px;
}

.paid-media-ads-performance-table.dashboard-data-table thead th {
  padding: 18px 24px;
  background: #ffffff;
  border-bottom: 1px solid #eef2f7;
  color: #a3adbd;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0;
  text-transform: uppercase;
}

.paid-media-ads-performance-table.dashboard-data-table thead th .dashboard-data-table__sort {
  text-transform: uppercase;
}

.paid-media-ads-performance-table.dashboard-data-table tbody td {
  height: 64px;
  padding: 18px 24px;
  border-top: 1px solid #eef2f7;
  color: #344054;
  font-size: 13px;
  font-weight: 500;
}

.paid-media-ads-performance-table.dashboard-data-table tbody tr:hover td {
  background: #ffffff;
}

.paid-media-ads-performance-table .paid-media-report__ad-col {
  min-width: 220px;
}

.paid-media-ads-performance-table .paid-media-table__entity-link {
  color: #1f2937;
  font-size: 13px;
  font-weight: 500;
}

.paid-media-ads-performance-table .paid-media-mini-tag--platform {
  height: auto;
  padding: 0;
  border: 0;
  background: transparent;
  color: #344054;
  font-size: 13px;
  font-weight: 600;
}

.paid-media-ads-performance-table td.paid-media-table__metric--success {
  color: #009e4f;
  font-weight: 800;
}

.paid-media-ads-table-panel .table-page-pagination {
  min-height: 64px;
  padding: 18px 24px;
  border-top: 1px solid #e5eaf1;
  background: #ffffff;
}

.paid-media-ads-table-panel .table-page-pagination__label {
  color: #7b8797;
  font-size: 13px;
  font-weight: 700;
}

.paid-media-ads-table-panel .table-page-pagination__btn {
  width: 32px;
  height: 32px;
  border-color: #e0e6ef;
  border-radius: 7px;
  background: #ffffff;
  color: #98a2b3;
}

.paid-media-export-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 45px;
  padding: 0 14px;
  border: 1px solid #d7e0ea;
  border-radius: 8px;
  background: #ffffff;
  color: #0f172a;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
}
.paid-media-export-btn:hover:not(:disabled) {
  background: #f8fafc;
  border-color: #c5d3e3;
}
.paid-media-export-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.paid-media-tabs-bar {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px;
  margin-bottom: 10px;
  background: #eef2f7;
  border-radius: 8px;
  border: 1px solid #e6edf5;
  box-shadow: none;
  margin-top: 20px;
}

.paid-media-tabs-bar__tab {
  height: 32px;
  padding: 0 16px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #60718b;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.paid-media-tabs-bar__tab--active {
  background: #ffffff;
  color: #0f172a;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05);
}

.paid-media-campaign-cell strong {
  display: block;
  margin-bottom: 5px;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.35;
  text-align: start;
}

.paid-media-campaign-cell {
  min-width: 220px;
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.paid-media-campaign-expand {
  display: inline-flex;
  justify-content: center;
  width: 24px;
  height: 24px;
  margin-top: 1px;
  padding: 0;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #60718b;
  cursor: pointer;
  flex-shrink: 0;
}
.paid-media-campaign-expand:hover {
  background: #eef2f7;
  color: #1f2937;
}
.paid-media-campaign-expand--placeholder {
  display: inline-block;
  width: 24px;
  flex-shrink: 0;
}

.paid-media-table-subrow {
  background: transparent;
}
.paid-media-table-subrow td {
  border-top: 0;
}

.paid-media-table-subrow__label {
  display: inline-block;
  padding-inline-start: 32px;
  color: #475569;
  font-size: 13px;
}

.paid-media-mini-tag--muted {
  display: inline-block;
  margin-top: 4px;
  color: #64748b;
  font-size: 12px;
  font-weight: 500;
}

.paid-media-empty-section {
  padding: 32px 20px;
  text-align: center;
  color: #64748b;
  font-size: 14px;
}

.paid-media-tab-grid {
  display: grid;
  gap: 16px;
  margin-bottom: 14px;
}

.paid-media-tab-grid--two {
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
}

.paid-media-heatmap {
  display: grid;
  gap: 12px;
}

.paid-media-heatmap__header,
.paid-media-heatmap__row {
  display: grid;
  grid-template-columns: 132px repeat(2, minmax(0, 1fr));
  gap: 18px;
  align-items: center;
}

.paid-media-heatmap__header--three-cols,
.paid-media-heatmap__row--three-cols {
  grid-template-columns: 132px repeat(3, minmax(0, 1fr));
}

.paid-media-heatmap__header {
  color: #52657f;
  font-size: 12px;
  font-weight: 500;
  margin-bottom: 2px;
}

.paid-media-heatmap__age {
  color: #475569;
  font-size: 13px;
}

.paid-media-heatmap__cell {
  display: grid;
  justify-items: center;
  gap: 6px;
  min-height: 42px !important;
  padding: 10px 6px;
  border-radius: 12px;
  color: #0f172a;
}

.paid-media-heatmap__cell strong {
  font-size: 14px;
}

.paid-media-heatmap__cell span {
  font-size: 11px;
  color: rgba(15, 23, 42, 0.72);
}

.paid-media-heatmap__legend {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-top: 4px;
  color: #60718b;
  font-size: 12px;
}

.paid-media-heatmap__legend-scale {
  display: inline-flex;
  gap: 4px;
}

.paid-media-heatmap__legend-scale span {
  width: 34px;
  height: 10px;
  border-radius: 999px;
}

.paid-media-region-cards {
  display: grid;
  gap: 10px;
  margin-bottom: 18px;
}

.paid-media-region-card {
  padding: 10px 14px 10px;
  border-radius: 14px;
  background: #5bbf8a;
  color: #ffffff;
}

.paid-media-region-card__head,
.paid-media-region-card__meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.paid-media-region-card__head {
  margin-bottom: 6px;
}

.paid-media-region-card__head strong {
  font-size: 14px;
}

.paid-media-region-card__head span {
  font-size: 13px;
  font-weight: 700;
}

.paid-media-region-card__meta {
  color: rgba(255, 255, 255, 0.84);
  font-size: 12px;
  white-space: nowrap;
}

.paid-media-alerts {
  display: grid;
  gap: 14px;
}

.paid-media-alerts__toolbar {
  display: flex;
  justify-content: flex-end;
}

.paid-media-primary-button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 40px;
  padding: 0 16px;
  border: 0;
  border-radius: 12px;
  background: #2b74e4;
  color: #ffffff;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}

.paid-media-panel__title-with-icon {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.paid-media-alert-rules,
.paid-media-triggered-list,
.paid-media-recommendations__stack {
  display: grid;
  gap: 10px;
}

.paid-media-alert-rule {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 12px 14px;
  border-radius: 14px;
  background: #f8fafc;
}

.paid-media-alert-rule__left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.paid-media-alert-rule__left strong,
.paid-media-triggered-item strong,
.paid-media-recommendation-card strong {
  display: block;
  font-size: 13px;
  font-weight: 700;
  color: #0f172a;
}

.paid-media-alert-rule__left span,
.paid-media-triggered-item span,
.paid-media-recommendation-card span {
  color: #64748b;
  font-size: 12px;
}

.paid-media-switch {
  position: relative;
  width: 50px;
  height: 28px;
  border: 0;
  border-radius: 999px;
  background: #e2e8f0;
  cursor: pointer;
}

.paid-media-switch span {
  position: absolute;
  top: 3px;
  inset-inline-start: 3px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #ffffff;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.18);
  transition: transform 0.2s ease;
}

.paid-media-switch--on {
  background: #2b74e4;
}

/* The knob starts at the track's leading edge (\`inset-inline-start\`) and slides toward the
   trailing edge, so the travel direction has to flip with the writing direction. */
.paid-media-switch--on span {
  transform: translateX(22px);
}

[dir=rtl] .paid-media-switch--on span {
  transform: translateX(-22px);
}

.paid-media-icon-button {
  width: 32px;
  height: 32px;
  border: 0;
  border-radius: 10px;
  background: transparent;
  color: #64748b;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.paid-media-triggered-list {
  min-height: 184px;
  margin-bottom: 18px;
}

.paid-media-triggered-list__empty {
  height: 100%;
  min-height: 184px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #64748b;
  font-size: 14px;
}

.paid-media-triggered-item {
  padding: 12px 14px;
  border-radius: 14px;
  border: 1px solid rgba(245, 158, 11, 0.25);
  background: rgba(245, 158, 11, 0.06);
}

.paid-media-triggered-item small {
  display: inline-flex;
  margin-top: 4px;
  font-size: 12px;
  font-weight: 700;
}

.paid-media-alert-value--success {
  color: #15803d;
}

.paid-media-alert-value--danger {
  color: #b91c1c;
}

.paid-media-recommendations {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px;
}

.paid-media-recommendations__label {
  margin-bottom: 10px;
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
}

.paid-media-recommendations__label--positive {
  color: #16a34a;
}

.paid-media-recommendations__label--negative {
  color: #ef4444;
}

.paid-media-recommendation-card {
  padding: 14px;
  border-radius: 14px;
}

.paid-media-recommendation-card--positive {
  border: 1px solid rgba(34, 197, 94, 0.25);
  background: rgba(34, 197, 94, 0.05);
}

.paid-media-recommendation-card--negative {
  border: 1px solid rgba(239, 68, 68, 0.22);
  background: rgba(239, 68, 68, 0.05);
}

.paid-media-recommendation-card em {
  font-style: normal;
  font-weight: 700;
}

.paid-media-recommendation-card--positive em {
  color: #15803d;
}

.paid-media-recommendation-card--negative em {
  color: #b91c1c;
}

.google-ads-report__header {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: flex-start;
  padding: 20px 18px 0;
}

.google-ads-report__header h2 {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
}

.google-ads-report__header p {
  margin: 6px 0 0;
  color: #64748b;
  font-size: 14px;
}

.google-ads-report__filters,
.google-ads-overview-grid,
.google-ads-dual-grid,
.google-ads-table-panel__head,
.google-ads-pagination,
.google-ads-report__table-filters {
  display: flex;
  gap: 16px;
}

.google-ads-report__filters,
.google-ads-report__table-filters {
  flex-wrap: wrap;
}

.google-ads-filter-chip select,
.google-ads-search input {
  width: 100%;
  border: 0;
  outline: none;
  background: transparent;
  color: #0f172a;
  font-size: 13px;
}

.google-ads-overview-grid,
.google-ads-dual-grid {
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(320px, 1fr);
  margin-bottom: 16px;
}

.google-ads-chart--large {
  height: 320px;
}

.google-ads-chart--medium {
  height: 260px;
}

.google-ads-funnel {
  display: grid;
  gap: 16px;
  padding-top: 16px;
}

.google-ads-funnel__meta,
.google-ads-table-panel__head,
.google-ads-pagination {
  justify-content: space-between;
  align-items: center;
}

.google-ads-funnel__bar {
  height: 16px;
  border-radius: 999px;
  background: #e2e8f0;
  overflow: hidden;
}

.google-ads-funnel__bar > div {
  height: 100%;
  border-radius: inherit;
}

.google-ads-search {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 240px;
  height: 40px;
  padding: 0 12px;
  border: 1px solid #d7dee8;
  border-radius: 14px;
  color: #64748b;
}

.google-ads-primary-cell {
  display: grid;
  gap: 4px;
}

.google-ads-primary-cell small {
  color: #64748b;
}

.google-ads-metric-strong {
  color: #2b74e4;
  font-weight: 700;
}

.google-ads-pagination {
  padding: 14px 18px 18px;
  font-size: 13px;
  color: #64748b;
}

.google-ads-pagination__actions {
  display: flex;
  gap: 8px;
}

.google-ads-pagination__actions button {
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #d7dee8;
  border-radius: 10px;
  background: #fff;
  cursor: pointer;
}

.google-ads-pagination__actions button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.google-ads-inner-tabs {
  display: flex;
  gap: 8px;
  padding: 8px;
  margin: 16px 0;
}

.google-ads-inner-tabs__button {
  height: 36px;
  padding: 0 16px;
  border: 0;
  border-radius: 12px;
  background: transparent;
  color: #64748b;
  font-weight: 600;
  cursor: pointer;
}

.google-ads-inner-tabs__button--active {
  background: #eff6ff;
  color: #1d4ed8;
}

.google-ads-mini-trend {
  width: 80px;
  height: 28px;
  margin: 0 auto;
}

.google-ads-table-panel--full {
  grid-column: 1/-1;
  min-width: 0;
}

.google-ads-table-panel--full:has(.paid-media-filter-dropdown--open) {
  overflow: visible;
}

.google-ads-table-panel--full .paid-media-filter-dropdown--open {
  z-index: 40;
}

.google-ads-table-panel--full .paid-media-filter-dropdown__menu {
  max-height: min(320px, 50vh - 16px);
  overflow-y: auto;
}

.google-ads-table-panel--full .paid-media-filter-dropdown--upward .paid-media-filter-dropdown__menu {
  top: auto;
  bottom: calc(100% + 8px);
}

.google-ads-table-panel--full .paid-media-table-toolbar {
  align-items: center;
  gap: 12px;
}

.google-ads-table-panel--full .dashboard-section-header__control {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  min-width: auto;
}

.google-ads-table-panel--full .paid-media-filter-dropdown__trigger {
  height: 45px;
  padding-inline-start: 14px;
  padding-inline-end: 34px;
  width: 250px;
  border-color: #d6dde8;
  border-radius: 8px;
  font-size: 14px;
  color: #344054;
}

.google-ads-table-panel--full .paid-media-table-toolbar__search {
  display: inline-flex;
  align-items: center;
  height: 45px;
  margin: 0;
  width: 250px;
  border-color: #d6dde8;
  border-radius: 8px;
  color: #7a8797;
}

.google-ads-table-panel--full .paid-media-table-toolbar__search input {
  color: #344054;
  font-size: 14px;
}

.google-ads-table-panel--full .paid-media-table-toolbar__search input::placeholder {
  color: #8a96a8;
}

/* Ad Group Performance table: stack tags below the name */
.google-ads-adgroup-table .paid-media-campaign-cell {
  flex-direction: column;
  gap: 4px;
}

.google-ads-adgroup-table .paid-media-campaign-cell strong {
  margin-bottom: 0;
}

.google-ads-adgroup-table .paid-media-tag-row {
  margin-top: 0;
}

.google-ads-report .dashboard-data-table thead th,
.google-ads-report .paid-media-table thead th {
  text-transform: uppercase;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.02em;
  color: #a3adbd;
}

.google-ads-report .dashboard-data-table thead th .dashboard-data-table__sort,
.google-ads-report .paid-media-table thead th .paid-media-table__sort {
  text-transform: uppercase;
}

.google-ads-report .paid-media-mini-tag--muted {
  margin-top: 0;
  padding: 3px 8px;
  border: 1px solid #f3f4f6;
  border-radius: 4px;
  background: #f9fafb;
  color: #9ca3af;
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
}

.google-ads-report .dashboard-data-table thead th.dashboard-data-table__number,
.google-ads-report .paid-media-table thead th.paid-media-table__number,
.google-ads-report .dashboard-data-table thead th.dashboard-data-table__number .dashboard-data-table__sort,
.google-ads-report .paid-media-table thead th.paid-media-table__number .paid-media-table__sort {
  text-align: start !important;
  justify-content: flex-start;
}

.google-ads-trend-cell {
  text-align: center;
}

.google-ads-heatmap {
  overflow-x: auto;
}

.google-ads-heatmap__table {
  width: 100%;
  border-collapse: collapse;
}

.google-ads-heatmap__table th,
.google-ads-heatmap__table td {
  padding: 10px;
  text-align: start;
}

.google-ads-heatmap__chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 72px;
  padding: 10px 12px;
  border-radius: 12px;
  background: rgba(43, 116, 228, 0.12);
  color: #2b74e4;
  font-weight: 700;
}

.google-ads-alerts {
  display: grid;
  gap: 14px;
}

.google-ads-alert-card {
  display: grid;
  grid-template-columns: 40px minmax(0, 1fr);
  gap: 14px;
  padding: 18px;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  background: #fff;
}

.google-ads-alert-card__icon {
  width: 40px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: #eff6ff;
  color: #1d4ed8;
}

.google-ads-alert-card h3 {
  margin: 0 0 6px;
  font-size: 15px;
}

.google-ads-alert-card p {
  margin: 0;
  color: #64748b;
  font-size: 14px;
  line-height: 1.5;
}

@media (max-width: 1400px) {
  .paid-media-kpi-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
@media (max-width: 1100px) {
  .paid-media-overview-grid,
  .paid-media-campaigns-grid,
  .paid-media-meta-charts .paid-media-chart--roas-stack,
  .paid-media-meta-charts .paid-media-chart--grouped,
  .paid-media-meta-charts .paid-media-chart--post-type,
  .paid-media-tab-grid--two,
  .paid-media-recommendations,
  .paid-media-kpi-grid,
  .google-ads-overview-grid,
  .google-ads-dual-grid {
    grid-template-columns: 1fr;
  }
  .paid-media-panel__header,
  .paid-media-table-panel__header,
  .dashboard-data-table-panel__header,
  .google-ads-report__header,
  .google-ads-table-panel__head,
  .google-ads-pagination {
    flex-direction: column;
    align-items: flex-start;
  }
  .paid-media-table-panel__search,
  .dashboard-data-table-panel__search {
    min-width: 100%;
  }
  .paid-media-panel__header-actions--trend {
    align-items: flex-end;
    margin-inline-start: 0;
    min-width: 0;
    width: 100%;
  }
  .paid-media-trend-granularity {
    align-self: flex-end;
  }
  .paid-media-trend-chips {
    justify-content: flex-end;
  }
  .paid-media-trend-pagination {
    width: 100%;
  }
  .paid-media-heatmap__header,
  .paid-media-heatmap__row {
    grid-template-columns: 90px repeat(2, minmax(0, 1fr));
    gap: 10px;
  }
  .paid-media-heatmap__header--three-cols,
  .paid-media-heatmap__row--three-cols {
    grid-template-columns: 90px repeat(3, minmax(0, 1fr));
  }
  .paid-media-region-card__head,
  .paid-media-region-card__meta {
    flex-wrap: wrap;
  }
}`, "",{"version":3,"sources":["webpack://./src/dashboards/paidMedia/components/Tabs/PaidMediaDashboard.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,aAAA;EACA,sBAAA;EACA,cAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;AAEF;;AACA;EACE,cAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;AAEF;;AACA;EACE,aAAA;EACA,sBAAA;EACA,cAAA;EACA,aAAA;EACA,WAAA;EACA,gBAAA;AAEF;;AACA;EACE,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AAEF;;AACA;EACE,cAAA;EACA,YAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,uEAAA;AAEF;;AACA;EACE,mBAAA;EACA,cAAA;EACA,4CAAA;AAEF;;AACA;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,0BAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAEF;;AACA;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAEF;;AACA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iCAAA;AAEF;;AACA;EACE,mBAAA;EACA,cAAA;AAEF;;AACA;EACE,gBAAA;EACA,MAAA;EACA,UAAA;EACA,2BAAA;EACA,qCAAA;EACA,gCAAA;AAEF;;AACA,6EAAA;AACA;EACE,uBAAA;EACA,mBAAA;EACA,gCAAA;EACA,mBAAA;AAEF;;AACA;EACE,UAAA;EACA,SAAA;AAEF;;AACA;EACE,uBAAA;EACA,mBAAA;AAEF;;AACA;;;EAAA;AAIA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,WAAA;AAEF;;AACA;EACE,SAAA;EACA,eAAA;EACA,2BAAA;EACA,eAAA;AAEF;;AACA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,yBAAA;EACA,cAAA;EACA,WAAA;EACA,eAAA;AAEF;;AACA;EACE,gBAAA;EACA,gBAAA;EACA,cAAA;AAEF;;AACA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAEF;;AACA;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAEF;;AACA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;EACA,kBAAA;EACA,iBAAA;AAEF;;AACA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AAEF;;AACA;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;AAEF;;AACA;EACE,SAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;AAEF;;AACA;EACE,cAAA;AAEF;;AACA;EACE,YAAA;EACA,eAAA;AAEF;;AACA;EACE,kBAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;AAEF;;AACA;EACE,WAAA;EACA,8BAAA;EACA,wBAAA;EACA,eAAA;EACA,gBAAA;AAEF;;AACA;EACE,qBAAA;EACA,YAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAEF;;AACA;EACE,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,0CAAA;EACA,WAAA;AAEF;;AACA;EACE,WAAA;EACA,aAAA;EACA,0CAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,iDAAA;EACA,YAAA;AAEF;;AACA;EACE,cAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;AAEF;;AACA;EACE,mBAAA;AAEF;;AACA;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;AAEF;;AACA;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AAEF;;AACA;EACE,kBAAA;EACA,sBAAA;EACA,QAAA;EACA,2BAAA;EACA,cAAA;EACA,oBAAA;AAEF;;AACA;EACE,uBAAA;AAEF;;AACA;EACE,mBAAA;AAEF;;AACA;EACE,iBAAA;AAEF;;AACA;EACE,aAAA;EACA,gDAAA;EACA,SAAA;EACA,mBAAA;AAEF;;AACA;;;;;;;EAOE,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,+EAAA;AAEF;;AACA,mGAAA;AACA;EACE,aAAA;EACA,gCAAA;EACA,wBAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;EACA,kBAAA;EACA,iBAAA;AAEF;;AACA;EACE,8CAAA;EACA,WAAA;AAEF;;AACA;EACE,aAAA;AAEF;;AACA;EACE,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,QAAA;EACA,WAAA;EACA,eAAA;AAEF;;AACA;EACE,sBAAA;EACA,gBAAA;AAEF;;AACA;EACE,eAAA;AAEF;;AACA;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,2BAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;AAEF;;AACA;EACE,mBAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;AAEF;;AACA;EACE,mBAAA;EACA,kBAAA;EACA,qBAAA;EACA,oCAAA;EACA,gBAAA;AAEF;;AACA;EACE,eAAA;AAEF;;AACA;EACE,cAAA;AAEF;;AACA;EACE,cAAA;AAEF;;AACA;;EAEE,aAAA;AAEF;;AACA;;EAEE,aAAA;EACA,0DAAA;EACA,SAAA;EACA,mBAAA;AAEF;;AACA,+EAAA;AACA;EACE,iBAAA;AAEF;;AACA;EACE,kBAAA;EACA,mBAAA;AAEF;;AACA;;EAEE,YAAA;AAEF;;AACA;;EAEE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;EACA,mBAAA;AAEF;;AACA;;EAEE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAEF;;AACA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;AAEF;;AACA;EACE,gBAAA;EACA,gBAAA;AAEF;;AACA;EACE,aAAA;EACA,kBAAA;EACA,iBAAA;AAEF;;AACA;EACE,aAAA;AAEF;;AACA;EACE,aAAA;AAEF;;AACA;EACE,aAAA;AAEF;;AACA;EACE,aAAA;AAEF;;AACA;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,QAAA;EACA,WAAA;AAEF;;AACA;EACE,uBAAA;EACA,eAAA;EACA,SAAA;AAEF;;AACA;EACE,sBAAA;EACA,iBAAA;EACA,qBAAA;EACA,yBAAA;EACA,SAAA;EACA,yBAAA;EACA,2BAAA;AAEF;;AACA;EACE,eAAA;EACA,mBAAA;AAEF;;AACA;EACE,oBAAA;EACA,eAAA;EACA,mBAAA;EACA,SAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;AAEF;;AACA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAEF;;AACA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;AAEF;;AACA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AAEF;;AACA;EACE,oBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,QAAA;EACA,oBAAA;EACA,SAAA;EACA,SAAA;EACA,YAAA;AAEF;;AACA;EACE,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;AAEF;;AACA;EACE,mBAAA;EACA,cAAA;EACA,4CAAA;AAEF;;AACA;EACE,aAAA;EACA,eAAA;EACA,yBAAA;EACA,QAAA;AAEF;;AACA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAEF;;AACA;EACE,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,4CAAA;AAEF;;AACA;EACE,UAAA;EACA,WAAA;EACA,oBAAA;AAEF;;AACA;EACE,eAAA;AAEF;;AACA;EACE,SAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;AAEF;;AACA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACF,aAAA;AAEA;;AACA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAEF;;AACA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;AAEF;;AACA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,4EAAA;AAEF;;AACA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AAEF;;AACA;EACE,cAAA;EACA,mBAAA;EACA,YAAA;AAEF;;AACA;EACE,aAAA;EACA,SAAA;AAEF;;AACA;EACE,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAEF;;AACA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AAEF;;AACA;EACE,cAAA;AAEF;;AACA;EACE,YAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;AAEF;;AACA;EACE,YAAA;EACA,mBAAA;AAEF;;AACA;EACE,aAAA;EACA,SAAA;AAEF;;AACA;EACE,aAAA;EACA,+CAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,gCAAA;AAEF;;AACA;EACE,gBAAA;AAEF;;AACA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AAEF;;AACA;EACE,aAAA;EACA,QAAA;EACA,YAAA;AAEF;;AACA;EACE,eAAA;EACA,cAAA;AAEF;;AACA;EACE,cAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAEF;;AACA;EACE,aAAA;EACA,kBAAA;EACA,QAAA;AAEF;;AACA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAEF;;AACA;EACE,cAAA;EACA,eAAA;AAEF;;AACA;EACE,aAAA;EACA,0CAAA;EACA,uBAAA;EACA,SAAA;AAEF;;AACA;EACE,SAAA;AAEF;;AACA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mDAAA;AAEF;;AACA;EACE,cAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AAEF;;AACA;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAEF;;AACA;EACE,+BAAA;EACA,mBAAA;EACA,QAAA;EACA,2BAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,uBAAA;AAEF;;AACA;EACE,WAAA;EACA,eAAA;AAEF;;AACA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,uBAAA;AAEF;;AACA;EACE,2BAAA;EACA,mBAAA;EACA,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AAEF;;AACA;EACE,gBAAA;EACA,SAAA;AAEF;;AACA;EACE,gBAAA;EACA,mBAAA;AAEF;;AACA;EACE,aAAA;EAEA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,SAAA;EACA,eAAA;AACF;;AAEA;EACE,aAAA;EACA,eAAA;EACA,yBAAA;EACA,SAAA;EACA,YAAA;AACF;;AAEA;EACE,gBAAA;EACA,gBAAA;EACA,eAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,gBAAA;EACA,uBAAA;EACA,yBAAA;AACF;;AAEA;EACE,gBAAA;EACA,WAAA;AACF;;AAEA;EACE,oBAAA;EACA,eAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;AACF;;AAEA;;EAEE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;AACF;;AAEA;EACE,YAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;AACF;;AAEA,oDAAA;AACA;EACE,oCAAA;EACA,qBAAA;EACA,cAAA;AACF;;AAEA;EACE,oCAAA;EACA,qBAAA;EACA,cAAA;AACF;;AAEA;EACE,oCAAA;EACA,qBAAA;EACA,cAAA;AACF;;AAEA;EACE,mCAAA;EACA,qBAAA;EACA,cAAA;AACF;;AAEA;EACE,kCAAA;EACA,qBAAA;EACA,cAAA;AACF;;AAEA;EACE,oCAAA;EACA,qBAAA;EACA,cAAA;AACF;;AAEA,6BAAA;AACA;EACE,oCAAA;EACA,qBAAA;EACA,cAAA;AACF;;AAEA;EACE,oCAAA;EACA,qBAAA;EACA,cAAA;AACF;;AAEA;EACE,mCAAA;EACA,qBAAA;EACA,cAAA;AACF;;AAEA;EACE,mCAAA;EACA,qBAAA;EACA,cAAA;AACF;;AAEA;EACE,oCAAA;EACA,qBAAA;EACA,cAAA;AACF;;AAEA;EACE,kCAAA;EACA,qBAAA;EACA,cAAA;AACF;;AAEA;EACE,mCAAA;EACA,qBAAA;EACA,cAAA;AACF;;AAEA;EACE,oCAAA;EACA,qBAAA;EACA,cAAA;AACF;;AAEA;EACE,oCAAA;EACA,qBAAA;EACA,cAAA;AACF;;AAEA;EACE,oCAAA;EACA,qBAAA;EACA,cAAA;AACF;;AAEA;EACE,mCAAA;EACA,qBAAA;EACA,cAAA;AACF;;AAEA;EACE,oCAAA;EACA,qBAAA;EACA,cAAA;AACF;;AAEA;EACE,kCAAA;EACA,qBAAA;EACA,cAAA;AACF;;AAEA,gDAAA;AACA;EACE,oCAAA;EACA,qBAAA;EACA,cAAA;AACF;;AAEA;EACE,oCAAA;EACA,qBAAA;EACA,cAAA;AACF;;AAEA,8BAAA;AACA;EACE,oCAAA;EACA,qBAAA;EACA,cAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;EACA,yBAAA;EACA,oBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;AACF;;AAEA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AACF;;AAEA;;EAEE,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;AACF;;AAEA;EACE,mCAAA;EACA,cAAA;AACF;;AAEA;EACE,oCAAA;EACA,cAAA;AACF;;AAEA;EACE,qCAAA;EACA,cAAA;AACF;;AAEA;EACE,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,eAAA;EACA,mBAAA;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,iBAAA;AACF;;AAEA;EACE,aAAA;EACA,iBAAA;AACF;;AAEA;EACE,aAAA;EACA,iBAAA;AACF;;AAEA,gCAAA;AACA;EACE,aAAA;EACA,gDAAA;EACA,SAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,oDAAA;EACA,SAAA;EACA,mBAAA;AACF;;AAEA;EACE,0BAAA;AACF;;AAEA;;EAEE,WAAA;EACA,gBAAA;AACF;;AAEA;;EAEE,aAAA;EACA,iBAAA;AACF;;AAEA;EACE,aAAA;EACA,iBAAA;AACF;;AAEA;EACE,aAAA;EACA,iBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AACF;;AAEA;EACE,aAAA;EACA,0DAAA;EACA,cAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,iBAAA;EACA,WAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;EACA,eAAA;AACF;;AAEA;EACE,aAAA;EACA,UAAA;AACF;;AAEA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,wBAAA;EAAA,mBAAA;EACA,kBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;AACF;;AAEA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AACF;;AAEA;EACE,cAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AACF;;AAEA;EACE,cAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;AACF;;AAEA;EACE,wBAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE;IACE,gDAAA;EACF;EAEA;IACE,0BAAA;EAAF;EAGA;IACE,0BAAA;EADF;EAIA;IACE,eAAA;EAFF;AACF;AAKA;EACE;IACE,0BAAA;EAHF;AACF;AAMA;EACE,uBAAA;AAJF;;AAOA;EACE,mBAAA;AAJF;;AAOA;EACE,iBAAA;AAJF;;AAOA;EACE,mCAAA;EACA,gBAAA;AAJF;;AAOA;;;;;;;EAAA;AAQA;EACE,cAAA;AAJF;;AAOA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;EACA,SAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;AAJF;;AAOA;EACE,aAAA;EACA,gBAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AAJF;;AAOA;;EAEE,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,+EAAA;EACA,mBAAA;AAJF;;AAOA;EACE,gBAAA;EACA,kBAAA;EACA,SAAA;AAJF;;AAOA;EACE,eAAA;EACA,iBAAA;AAJF;;AAOA;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AAJF;;AAOA;EACE,eAAA;EACA,yBAAA;AAJF;;AAOA;EACE,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AAJF;;AAOA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;AAJF;;AAOA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAJF;;AAOA;EACE,cAAA;EACA,gBAAA;EACA,eAAA;AAJF;;AAOA;EACE,qBAAA;EACA,kBAAA;EACA,8EAAA;AAJF;;AAOA;EACE,gBAAA;EACA,kBAAA;EACA,gCAAA;AAJF;;AAOA;EACE,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAJF;;AAOA;EACE,mBAAA;EACA,cAAA;EACA,SAAA;AAJF;;AAOA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,SAAA;EACA,qBAAA;EACA,kBAAA;EACA,cAAA;AAJF;;AAOA;EACE,cAAA;EACA,eAAA;AAJF;;AAOA;EACE,cAAA;AAJF;;AAOA;EACE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,eAAA;EACA,qBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAJF;;AAOA;EACE,iBAAA;AAJF;;AAOA;EACE,kBAAA;EACA,mBAAA;EACA,gCAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AAJF;;AAOA;EACE,yBAAA;AAJF;;AAOA;EACE,YAAA;EACA,kBAAA;EACA,6BAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAJF;;AAOA;EACE,mBAAA;AAJF;;AAOA;EACE,YAAA;EACA,oCAAA;EACA,yBAAA;AAJF;;AAOA;EACE,oCAAA;AAJF;;AAOA;EACE,gBAAA;EACA,QAAA;AAJF;;AAOA;EACE,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAJF;;AAOA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;AAJF;;AAOA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAJF;;AAOA;EACE,aAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAJF;;AAOA;EACE,aAAA;EACA,QAAA;EACA,0BAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAJF;;AAOA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAJF;;AAOA;EACE,cAAA;EACA,gBAAA;AAJF;;AAOA;EACE,gBAAA;EACA,kBAAA;EACA,6BAAA;EACA,mBAAA;AAJF;;AAOA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAJF;;AAOA;EACE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;AAJF;;AAOA;EACE,qBAAA;EACA,kBAAA;EACA,8EAAA;AAJF;;AAOA;EACE,gBAAA;EACA,kBAAA;EACA,gCAAA;AAJF;;AAOA;EACE,QAAA;AAJF;;AAOA;EACE,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAJF;;AAOA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAJF;;AAOA;EACE,mBAAA;EACA,cAAA;EACA,SAAA;AAJF;;AAOA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,SAAA;EACA,qBAAA;EACA,kBAAA;EACA,cAAA;AAJF;;AAOA;EACE,cAAA;EACA,eAAA;AAJF;;AAOA;EACE,cAAA;AAJF;;AAOA;EACE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,eAAA;EACA,qBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAJF;;AAOA;EACE,iBAAA;AAJF;;AAOA;EACE,kBAAA;EACA,mBAAA;EACA,gCAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AAJF;;AAOA;EACE,yBAAA;AAJF;;AAOA;EACE,YAAA;EACA,kBAAA;EACA,6BAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAJF;;AAOA;EACE,mBAAA;AAJF;;AAOA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAJF;;AAOA;EACE,cAAA;EACA,gBAAA;AAJF;;AAOA;EACE,gBAAA;EACA,kBAAA;EACA,6BAAA;EACA,mBAAA;AAJF;;AAOA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAJF;;AAOA;EACE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;AAJF;;AAOA;EACE,qBAAA;EACA,kBAAA;EACA,8EAAA;AAJF;;AAOA;EACE,gBAAA;EACA,kBAAA;EACA,gCAAA;AAJF;;AAOA;EACE,QAAA;AAJF;;AAOA;EACE,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAJF;;AAOA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAJF;;AAOA;EACE,mBAAA;EACA,cAAA;EACA,SAAA;AAJF;;AAOA;;EAEE,YAAA;AAJF;;AAOA;EACE,YAAA;AAJF;;AAOA;EACE,YAAA;EACA,0BAAA;EACA,wBAAA;EACA,qBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAJF;;AAOA;EACE,cAAA;AAJF;;AAOA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,SAAA;EACA,qBAAA;EACA,kBAAA;EACA,cAAA;AAJF;;AAOA;EACE,cAAA;EACA,eAAA;AAJF;;AAOA;EACE,cAAA;AAJF;;AAOA;EACE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,eAAA;EACA,qBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAJF;;AAOA;EACE,iBAAA;AAJF;;AAOA;EACE,kBAAA;EACA,mBAAA;EACA,gCAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AAJF;;AAOA;EACE,yBAAA;AAJF;;AAOA;EACE,YAAA;EACA,kBAAA;EACA,6BAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAJF;;AAOA;EACE,mBAAA;AAJF;;AAOA;EACE,gBAAA;AAJF;;AAOA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAJF;;AAOA;EACE,YAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAJF;;AAOA;EACE,cAAA;EACA,gBAAA;AAJF;;AAOA;EACE,gBAAA;EACA,kBAAA;EACA,6BAAA;EACA,mBAAA;AAJF;;AAOA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAJF;;AAOA;EACE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;AAJF;;AAOA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;AAJF;AAME;EACE,mBAAA;EACA,qBAAA;AAJJ;AAOE;EACE,YAAA;EACA,mBAAA;AALJ;;AASA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,gBAAA;AANF;;AASA;EACE,YAAA;EACA,eAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AANF;;AASA;EACE,mBAAA;EACA,cAAA;EACA,4CAAA;AANF;;AASA;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;AANF;;AASA;EACE,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,QAAA;AANF;;AASA;EACE,oBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;AANF;AAQE;EACE,mBAAA;EACA,cAAA;AANJ;AASE;EACE,qBAAA;EACA,WAAA;EACA,cAAA;AAPJ;;AAWA;EACE,uBAAA;AARF;AAUE;EACE,aAAA;AARJ;;AAYA;EACE,qBAAA;EACA,0BAAA;EACA,cAAA;EACA,eAAA;AATF;;AAYA;EACE,qBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AATF;;AAYA;EACE,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AATF;;AAYA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AATF;;AAYA;EACE,oDAAA;AATF;;AAYA;EACE,aAAA;EACA,SAAA;AATF;;AAYA;;EAEE,aAAA;EACA,sDAAA;EACA,SAAA;EACA,mBAAA;AATF;;AAYA;;EAEE,sDAAA;AATF;;AAYA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AATF;;AAYA;EACE,cAAA;EACA,eAAA;AATF;;AAYA;EACE,aAAA;EACE,qBAAA;EACA,QAAA;EACA,2BAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;AATJ;;AAYA;EACE,eAAA;AATF;;AAYA;EACE,eAAA;EACA,6BAAA;AATF;;AAYA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AATF;;AAYA;EACE,oBAAA;EACA,QAAA;AATF;;AAYA;EACE,WAAA;EACA,YAAA;EACA,oBAAA;AATF;;AAYA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AATF;;AAYA;EACE,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;AATF;;AAYA;;EAEE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AATF;;AAYA;EACE,kBAAA;AATF;;AAYA;EACE,eAAA;AATF;;AAYA;EACE,eAAA;EACA,gBAAA;AATF;;AAYA;EACE,gCAAA;EACA,eAAA;EACA,mBAAA;AATF;;AAYA;EACE,aAAA;EACA,SAAA;AATF;;AAYA;EACE,aAAA;EACA,yBAAA;AATF;;AAYA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AATF;;AAYA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;AATF;;AAYA;;;EAGE,aAAA;EACA,SAAA;AATF;;AAYA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;AATF;;AAYA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AATF;;AAYA;;;EAGE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AATF;;AAYA;;;EAGE,cAAA;EACA,eAAA;AATF;;AAYA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,oBAAA;EACA,mBAAA;EACA,eAAA;AATF;;AAYA;EACE,kBAAA;EACA,QAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,4CAAA;EACA,+BAAA;AATF;;AAYA;EACE,mBAAA;AATF;;AAYA;mFAAA;AAEA;EACE,2BAAA;AATF;;AAYA;EACE,4BAAA;AATF;;AAYA;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AATF;;AAYA;EACE,iBAAA;EACA,mBAAA;AATF;;AAYA;EACE,YAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;AATF;;AAYA;EACE,kBAAA;EACA,mBAAA;EACA,0CAAA;EACA,oCAAA;AATF;;AAYA;EACE,oBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;AATF;;AAYA;EACE,cAAA;AATF;;AAYA;EACE,cAAA;AATF;;AAYA;EACE,aAAA;EACA,gDAAA;EACA,SAAA;AATF;;AAYA;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AATF;;AAYA;EACE,cAAA;AATF;;AAYA;EACE,cAAA;AATF;;AAYA;EACE,aAAA;EACA,mBAAA;AATF;;AAYA;EACE,yCAAA;EACA,mCAAA;AATF;;AAYA;EACE,yCAAA;EACA,mCAAA;AATF;;AAYA;EACE,kBAAA;EACA,gBAAA;AATF;;AAYA;EACE,cAAA;AATF;;AAYA;EACE,cAAA;AATF;;AAYA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,uBAAA;EACA,oBAAA;AATF;;AAYA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;AATF;;AAYA;EACE,eAAA;EACA,cAAA;EACA,eAAA;AATF;;AAYA;;;;;;EAME,aAAA;EACA,SAAA;AATF;;AAYA;;EAEE,eAAA;AATF;;AAYA;;EAEE,WAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;AATF;;AAYA;;EAEE,aAAA;EACA,wDAAA;EACA,mBAAA;AATF;;AAYA;EACE,aAAA;AATF;;AAYA;EACE,aAAA;AATF;;AAYA;EACE,aAAA;EACA,SAAA;EACA,iBAAA;AATF;;AAYA;;;EAGE,8BAAA;EACA,mBAAA;AATF;;AAYA;EACE,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;AATF;;AAYA;EACE,YAAA;EACA,sBAAA;AATF;;AAYA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;AATF;;AAYA;EACE,aAAA;EACA,QAAA;AATF;;AAYA;EACE,cAAA;AATF;;AAYA;EACE,cAAA;EACA,gBAAA;AATF;;AAYA;EACE,uBAAA;EACA,eAAA;EACA,cAAA;AATF;;AAYA;EACE,aAAA;EACA,QAAA;AATF;;AAYA;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;AATF;;AAYA;EACE,aAAA;EACA,mBAAA;AATF;;AAYA;EACE,aAAA;EACA,QAAA;EACA,YAAA;EACA,cAAA;AATF;;AAYA;EACE,YAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AATF;;AAYA;EACE,mBAAA;EACA,cAAA;AATF;;AAYA;EACE,WAAA;EACA,YAAA;EACA,cAAA;AATF;;AAYA;EACE,iBAAA;EACA,YAAA;AATF;;AAYA;EACE,iBAAA;AATF;;AAYA;EACE,WAAA;AATF;;AAYA;EACE,mCAAA;EACA,gBAAA;AATF;;AAYA;EACE,SAAA;EACA,wBAAA;AATF;;AAYA;EACE,mBAAA;EACA,SAAA;AATF;;AAYA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;AATF;;AAYA;EACE,YAAA;EACA,0BAAA;EACA,wBAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AATF;;AAYA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,SAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,cAAA;AATF;;AAYA;EACE,cAAA;EACA,eAAA;AATF;;AAYA;EACE,cAAA;AATF;;AAYA,0DAAA;AACA;EACE,sBAAA;EACA,QAAA;AATF;;AAYA;EACE,gBAAA;AATF;;AAYA;EACE,aAAA;AATF;;AAYA;;EAEE,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;AATF;;AAYA;;EAEE,yBAAA;AATF;;AAYA;EACE,aAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AATF;;AAaA;;;;EAIE,4BAAA;EACA,2BAAA;AAVF;;AAaA;EACE,kBAAA;AAVF;;AAaA;EACE,gBAAA;AAVF;;AAaA;EACE,WAAA;EACA,yBAAA;AAVF;;AAaA;;EAEE,aAAA;EACA,iBAAA;AAVF;;AAaA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,oCAAA;EACA,cAAA;EACA,gBAAA;AAVF;;AAaA;EACE,aAAA;EACA,SAAA;AAVF;;AAaA;EACE,aAAA;EACA,0CAAA;EACA,SAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;AAVF;;AAaA;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;AAVF;;AAaA;EACE,eAAA;EACA,eAAA;AAVF;;AAaA;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAVF;;AAaA;EACE;IACE,gDAAA;EAVF;AACF;AAaA;EACE;;;;;;;;;;IAUE,0BAAA;EAXF;EAcA;;;;;;IAME,sBAAA;IACA,uBAAA;EAZF;EAeA;;IAEE,eAAA;EAbF;EAgBA;IACE,qBAAA;IACA,sBAAA;IACA,YAAA;IACA,WAAA;EAdF;EAiBA;IACE,oBAAA;EAfF;EAkBA;IACE,yBAAA;EAhBF;EAmBA;IACE,WAAA;EAjBF;EAoBA;;IAEE,qDAAA;IACA,SAAA;EAlBF;EAqBA;;IAEE,qDAAA;EAnBF;EAsBA;;IAEE,eAAA;EApBF;AACF","sourcesContent":[".paid-media-dashboard-with-data {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  min-height: 0;\n  width: 100%;\n  height: 100%;\n  max-height: 100%;\n  overflow: hidden;\n}\n\n.paid-media-dashboard-with-data > * {\n  flex: 1 1 auto;\n  min-height: 0;\n  min-width: 0;\n  width: 100%;\n}\n\n.paid-media-tabs-dashboard {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  min-height: 0;\n  width: 100%;\n  overflow: hidden;\n}\n\n.paid-media-tabs-dashboard__tabs {\n  align-self: flex-start;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 16px;\n  padding: 8px;\n  border-radius: 20px;\n  background: #eaf0f7;\n  width: fit-content;\n  max-width: 100%;\n  flex-shrink: 0;\n}\n\n.paid-media-tabs-dashboard__tab {\n  flex-shrink: 0;\n  height: 38px;\n  padding: 0 22px;\n  border: 0;\n  border-radius: 14px;\n  background: transparent;\n  color: #60718b;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: background 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.paid-media-tabs-dashboard__tab--active {\n  background: #ffffff;\n  color: #0f172a;\n  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.08);\n}\n\n.paid-media-tabs-dashboard__coming-soon {\n  min-height: 320px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px dashed #cfd9e6;\n  border-radius: 20px;\n  background: #ffffff;\n  color: #60718b;\n  font-size: 15px;\n  font-weight: 600;\n}\n\n.paid-media-tabs-dashboard__loading {\n  min-height: 320px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.paid-media-dashboard {\n  flex: 1 1 auto;\n  min-height: 0;\n  background: #ffffff;\n  border-radius: 20px;\n  overflow-x: hidden;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.paid-media-report {\n  background: #ffffff;\n  color: #0f172a;\n}\n\n.paid-media-toolbar {\n  position: sticky;\n  top: 0;\n  z-index: 5;\n  backdrop-filter: blur(10px);\n  background: rgba(255, 255, 255, 0.92);\n  border-bottom: 1px solid #e2e8f0;\n}\n\n/** Title + date row and filter row are grouped; border sits below filters. */\n.paid-media-report__header-block {\n  padding: 18px 18px 16px;\n  margin-bottom: 16px;\n  border-bottom: 1px solid #e4e7ec;\n  background: #ffffff;\n}\n\n.paid-media-report__header-block .paid-media-report__section-header {\n  padding: 0;\n  margin: 0;\n}\n\n.paid-media-report__section-header {\n  padding: 18px 18px 16px;\n  margin-bottom: 16px;\n}\n\n/**\n * Second row: subtext left (grows), Campaigns / Platforms / Regions right — same baseline as the reference.\n * (No Clear control.)\n */\n.paid-media-report__subtitle-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px 20px;\n  margin-top: 6px;\n  width: 100%;\n}\n\n.paid-media-report__header-subtitle {\n  margin: 0;\n  flex: 1 1 200px;\n  min-width: min(100%, 200px);\n  max-width: none;\n}\n\n.paid-media-report__filters-bar {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  align-items: center;\n  justify-content: flex-end;\n  margin-top: 0;\n  margin-inline-start: auto;\n  flex: 0 0 auto;\n  width: auto;\n  max-width: 100%;\n}\n\n.paid-media-report__filters-bar .dashboard-section-header__control {\n  min-width: 260px;\n  max-width: 260px;\n  flex: 0 0 auto;\n}\n\n.paid-media-report__title {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 700;\n  color: #101828;\n}\n\n.paid-media-report__subtitle {\n  margin: 0;\n  color: #667085;\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.paid-media-toolbar__inner {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 12px;\n  padding: 12px 16px;\n  overflow: visible;\n}\n\n.paid-media-filter-icon {\n  width: 44px;\n  height: 44px;\n  border-radius: 12px;\n  color: #60718b;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.paid-media-filter-chip {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  height: 44px;\n  width: 100%;\n  padding: 0 16px;\n  border: 1px solid #dde5ef;\n  border-radius: 8px;\n  background: #ffffff;\n  flex-shrink: 0;\n  overflow: hidden;\n  color: #0f172a;\n}\n\n.paid-media-filter-chip input {\n  border: 0;\n  background: transparent;\n  color: #0f172a;\n  font-size: 13px;\n  outline: none;\n}\n\n.paid-media-toolbar__date-range {\n  flex-shrink: 0;\n}\n\n.paid-media-filter-chip:not(.paid-media-filter-chip--date) {\n  min-width: 0;\n  max-width: none;\n}\n\n.paid-media-filter-dropdown {\n  position: relative;\n  flex-shrink: 0;\n  min-width: 0;\n  z-index: 30;\n}\n\n.paid-media-filter-dropdown__trigger {\n  width: 100%;\n  justify-content: space-between;\n  padding-inline-end: 38px;\n  cursor: pointer;\n  overflow: hidden;\n}\n\n.paid-media-filter-dropdown__label {\n  display: inline-block;\n  min-width: 0;\n  max-width: calc(100% - 30px);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.paid-media-filter-dropdown__menu {\n  position: absolute;\n  top: calc(100% + 8px);\n  inset-inline-start: 0;\n  min-width: 260px;\n  max-width: 420px;\n  width: max-content;\n  padding: 6px;\n  border: 1px solid #e6edf7;\n  border-radius: 12px;\n  background: #ffffff;\n  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);\n  z-index: 20;\n}\n\n.paid-media-filter-dropdown__item {\n  width: 100%;\n  display: grid;\n  grid-template-columns: 20px minmax(0, 1fr);\n  align-items: center;\n  gap: 10px;\n  padding: 10px 12px;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  color: #0f172a;\n  font-size: 13px;\n  text-align: start;\n  cursor: pointer;\n  transition: background 0.2s ease, color 0.2s ease;\n  min-width: 0;\n}\n\n.paid-media-filter-dropdown__item span:last-child {\n  display: block;\n  min-width: 0;\n  white-space: normal;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n.paid-media-filter-dropdown__item:hover {\n  background: #f2f2f2;\n}\n\n.paid-media-filter-dropdown__item--selected {\n  background: #e4e4e4;\n  color: #1f1f1f;\n  font-weight: 600;\n}\n\n.paid-media-filter-dropdown__check {\n  width: 16px;\n  height: 16px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: #0f172a;\n}\n\n.paid-media-filter-chip__chevron {\n  position: absolute;\n  inset-inline-end: 14px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #7b8aa0;\n  pointer-events: none;\n}\n\n.paid-media-report__content {\n  padding: 10px 18px 18px;\n}\n\n.paid-media-report__content .dashboard-narrative-panel {\n  margin-bottom: 16px;\n}\n\n.paid-media-report__loading {\n  min-height: 320px;\n}\n\n.paid-media-kpi-grid {\n  display: grid;\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n  gap: 14px;\n  margin-bottom: 14px;\n}\n\n.paid-media-kpi-card,\n.paid-media-panel,\n.paid-media-table-panel,\n.dashboard-data-table-panel,\n.paid-media-empty-state,\n.paid-media-empty-section,\n.paid-media-tabs-bar {\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #ffffff;\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04), 0 4px 12px rgba(15, 23, 42, 0.03);\n}\n\n/* KPI tiles use global DashboardKpiCard (flex column: title + ?, value, period; icon top-right). */\n.paid-media-kpi-card {\n  padding: 18px;\n  transition: box-shadow 0.2s ease;\n  display: flex !important;\n  flex-direction: column;\n  gap: 12px;\n  min-height: 0;\n  position: relative;\n  overflow: visible;\n}\n\n.paid-media-kpi-card:hover {\n  box-shadow: 0 16px 30px rgba(15, 23, 42, 0.08);\n  z-index: 20;\n}\n\n.paid-media-kpi-card.dashboard-kpi-card .dashboard-kpi-card__header {\n  margin-top: 0;\n}\n\n.paid-media-kpi-card.dashboard-kpi-card .dashboard-kpi-card__title-row {\n  display: inline-flex;\n  align-items: center;\n  align-self: flex-start;\n  gap: 5px;\n  width: 100%;\n  max-width: 100%;\n}\n\n.paid-media-kpi-card.dashboard-kpi-card .dashboard-kpi-card__title-row .definition-tooltip {\n  align-self: flex-start;\n  margin-top: -1px;\n}\n\n.paid-media-kpi-card.dashboard-kpi-card .dashboard-kpi-card__title-row .definition-tooltip__trigger {\n  transform: none;\n}\n\n.paid-media-kpi-card.dashboard-kpi-card .dashboard-kpi-card__title {\n  flex: 0 1 auto;\n  font-size: 10px;\n  line-height: 1.35;\n  letter-spacing: 0.08em;\n  max-width: min(100%, 180px);\n  white-space: nowrap;\n  display: block;\n  -webkit-line-clamp: unset;\n  -webkit-box-orient: unset;\n  line-clamp: unset;\n  max-height: none;\n  text-overflow: ellipsis;\n}\n\n.paid-media-kpi-card--long-title.dashboard-kpi-card .dashboard-kpi-card__title {\n  white-space: normal;\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  line-clamp: 2;\n  max-height: calc(1.35em * 2);\n  text-overflow: clip;\n}\n\n.paid-media-kpi-card.dashboard-kpi-card .dashboard-kpi-card__value {\n  white-space: normal;\n  word-break: normal;\n  overflow-wrap: normal;\n  font-size: clamp(18px, 1.45vw, 24px);\n  line-height: 1.2;\n}\n\n.paid-media-kpi-card.dashboard-kpi-card .dashboard-kpi-card__period {\n  font-size: 12px;\n}\n\n.paid-media-kpi-card.dashboard-kpi-card .dashboard-kpi-card__change--positive {\n  color: #15803d;\n}\n\n.paid-media-kpi-card.dashboard-kpi-card .dashboard-kpi-card__change--negative {\n  color: #b91c1c;\n}\n\n.paid-media-kpi-card .recharts-tooltip-wrapper,\n.paid-media-panel .recharts-tooltip-wrapper {\n  z-index: 1000;\n}\n\n.paid-media-overview-grid,\n.paid-media-campaigns-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 2.1fr) minmax(320px, 1fr);\n  gap: 16px;\n  margin-bottom: 14px;\n}\n\n/* When only one chart remains (e.g. Meta Ads campaigns), span full row width */\n.paid-media-campaigns-grid > .paid-media-panel:only-child {\n  grid-column: 1 / -1;\n}\n\n.paid-media-panel {\n  padding: 20px 20px;\n  margin-bottom: 20px;\n}\n\n.paid-media-panel--wide,\n.paid-media-panel--trend {\n  min-width: 0;\n}\n\n.paid-media-panel__header,\n.paid-media-table-panel__header {\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n.paid-media-panel__header h3,\n.paid-media-table-panel__header h3 {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 700;\n  color: #0f172a;\n  margin-bottom: 10px;\n}\n\n.paid-media-panel__heading {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  min-width: 0;\n}\n\n.paid-media-panel__heading h3 {\n  margin-bottom: 0;\n  line-height: 1.2;\n}\n\n.paid-media-chart {\n  height: 240px;\n  position: relative;\n  overflow: visible;\n}\n\n.paid-media-chart--trend {\n  height: 300px;\n}\n\n.paid-media-chart--pie {\n  height: 220px;\n}\n\n.paid-media-chart--compact {\n  height: 260px;\n}\n\n.paid-media-chart--ads {\n  height: 230px;\n}\n\n.paid-media-panel__header-actions {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 8px;\n  width: 100%;\n}\n\n.paid-media-panel__header--trend {\n  align-items: flex-start;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n.paid-media-panel__header-actions--trend {\n  flex-direction: column;\n  flex-wrap: nowrap;\n  align-items: flex-end;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-inline-start: auto;\n  min-width: min(100%, 360px);\n}\n\n.paid-media-panel__header--with-legend {\n  flex-wrap: wrap;\n  align-items: center;\n}\n\n.paid-media-chart-legend {\n  display: inline-flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 16px;\n  margin-inline-start: auto;\n  list-style: none;\n  margin-block: 0;\n  padding-inline-start: 0;\n}\n\n.paid-media-chart-legend__item {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  color: #64748b;\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.paid-media-chart-legend__swatch {\n  width: 12px;\n  height: 12px;\n  border-radius: 3px;\n  flex-shrink: 0;\n}\n\n.paid-media-visually-hidden {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n.paid-media-trend-granularity {\n  display: inline-flex;\n  padding: 2px;\n  border-radius: 8px;\n  background: #edf3fb;\n  gap: 2px;\n  align-self: flex-end;\n  border: 0;\n  margin: 0;\n  min-width: 0;\n}\n\n.paid-media-trend-granularity__btn {\n  border: 0;\n  border-radius: 7px;\n  background: transparent;\n  color: #64748b;\n  font-size: 10px;\n  font-weight: 700;\n  line-height: 1;\n  min-width: 48px;\n  height: 28px;\n  padding: 0 12px;\n  cursor: pointer;\n}\n\n.paid-media-trend-granularity__btn--active {\n  background: #ffffff;\n  color: #000000;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08);\n}\n\n.paid-media-trend-chips {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n.paid-media-trend-chips__item {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  height: 28px;\n  min-width: 78px;\n  padding: 0 12px;\n  border: 1px solid #dce3ed;\n  border-radius: 999px;\n  background: #ffffff;\n  color: #64748b;\n  font-size: 10px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.paid-media-trend-chips__item--active {\n  background: #EEF4FF;\n  color: #6B7280;\n  border-color: none;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08);\n}\n\n.paid-media-trend-chips__dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 999px;\n}\n\n.paid-media-trend-chips--legend .paid-media-trend-chips__item {\n  cursor: pointer;\n}\n\nfieldset.paid-media-trend-chips--legend {\n  border: 0;\n  margin: 0;\n  padding: 0;\n  min-width: 0;\n}\n\n.paid-media-trend-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\npadding: 10px;\n}\n\n.paid-media-trend-pagination__label {\n  color: #7b8797;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.paid-media-trend-pagination__nav {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.paid-media-trend-pagination__btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border: 1px solid #dce3ed;\n  border-radius: 7px;\n  background: #ffffff;\n  color: #64748b;\n  cursor: pointer;\n  transition: background 0.16s ease, border-color 0.16s ease, color 0.16s ease;\n}\n\n.paid-media-trend-pagination__btn:hover:not(:disabled) {\n  background: #f8fafc;\n  border-color: #cbd5e1;\n  color: #334155;\n}\n\n.paid-media-trend-pagination__btn:disabled {\n  color: #cbd5e1;\n  cursor: not-allowed;\n  opacity: 0.8;\n}\n\n.paid-media-funnel {\n  display: grid;\n  gap: 16px;\n}\n\n.paid-media-funnel__drop {\n  margin-bottom: 6px;\n  color: #dc2626;\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.paid-media-funnel__meta {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 6px;\n  color: #475569;\n  font-size: 12px;\n}\n\n.paid-media-funnel__meta strong {\n  color: #0f172a;\n}\n\n.paid-media-funnel__track {\n  height: 48px;\n  padding: 5px;\n  border-radius: 12px;\n  background: #eef2f7;\n}\n\n.paid-media-funnel__fill {\n  height: 100%;\n  border-radius: 10px;\n}\n\n.paid-media-list {\n  display: grid;\n  gap: 12px;\n}\n\n.paid-media-list__item {\n  display: grid;\n  grid-template-columns: auto minmax(0, 1fr) auto;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 0;\n  border-bottom: 1px solid #eef2f7;\n}\n\n.paid-media-list__item:last-child {\n  border-bottom: 0;\n}\n\n.paid-media-list__icon {\n  width: 42px;\n  height: 42px;\n  border-radius: 14px;\n  background: #eff6ff;\n  color: #2563eb;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.paid-media-list__content {\n  display: grid;\n  gap: 3px;\n  min-width: 0;\n}\n\n.paid-media-list__content strong {\n  font-size: 13px;\n  color: #0f172a;\n}\n\n.paid-media-list__content span {\n  color: #64748b;\n  font-size: 12px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.paid-media-list__value {\n  display: grid;\n  justify-items: end;\n  gap: 2px;\n}\n\n.paid-media-list__value span {\n  font-size: 16px;\n  font-weight: 700;\n  color: #16a34a;\n}\n\n.paid-media-list__value small {\n  color: #64748b;\n  font-size: 11px;\n}\n\n.paid-media-creative {\n  display: grid;\n  grid-template-columns: auto minmax(0, 1fr);\n  align-items: flex-start;\n  gap: 10px;\n}\n\n.paid-media-creative--inline {\n  gap: 12px;\n}\n\n.paid-media-creative__thumb {\n  width: 40px;\n  height: 40px;\n  border-radius: 8px;\n  background: #f3f6fa;\n  color: #94a3b8;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.85);\n}\n\n.paid-media-creative__thumb span {\n  font-size: 9px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.paid-media-creative strong {\n  display: block;\n  margin-bottom: 4px;\n  font-size: 12px;\n  font-weight: 600;\n  text-align: start;\n}\n\n.paid-media-creative__title-inline {\n  display: inline-flex !important;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 0 !important;\n  min-width: 0;\n  white-space: normal;\n  word-break: normal;\n  overflow-wrap: anywhere;\n}\n\n.paid-media-creative span {\n  color: #000;\n  font-size: 10px;\n}\n\n.paid-media-tag-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 4px;\n  min-width: 0;\n  width: 100%;\n  align-items: flex-start;\n}\n\n.paid-media-tag-row .paid-media-mini-tag {\n  max-width: min(100%, 320px);\n  white-space: normal;\n  word-break: normal;\n  overflow-wrap: anywhere;\n  height: auto;\n  min-height: 21px;\n  padding-top: 2px;\n  padding-bottom: 2px;\n  line-height: 1.2;\n}\n\n.paid-media-report__ad-col {\n  min-width: 340px;\n  width: 1%;\n}\n\n.paid-media-report__ad-id-col {\n  min-width: 120px;\n  white-space: nowrap;\n}\n\n.paid-media-table-toolbar {\n  display: flex;\n  //flex: 1 1 540px;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 12px;\n  min-width: auto;\n}\n\n.paid-media-table-toolbar__filters {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  gap: 12px;\n  min-width: 0;\n}\n\n.paid-media-table-toolbar__filter {\n  min-width: 220px;\n  max-width: 320px;\n  flex: 0 1 280px;\n}\n\n.paid-media-table-toolbar__filter .paid-media-filter-dropdown {\n  width: 100%;\n}\n\n.paid-media-table-toolbar__search {\n  min-width: 260px;\n  width: min(100%, 360px);\n  margin-inline-start: auto;\n}\n\n.google-ads-report__ad-id-col {\n  min-width: 260px;\n  width: auto;\n}\n\n.google-ads-report__ad-id-col .paid-media-mini-tag {\n  display: inline-flex;\n  max-width: 100%;\n  white-space: normal;\n  word-break: break-word;\n  overflow-wrap: anywhere;\n}\n\n.paid-media-mini-tag,\n.paid-media-status-chip {\n  display: inline-flex;\n  align-items: center;\n  height: 21px;\n  padding: 0 7px;\n  border: 1px solid #cfd9e6;\n  border-radius: 6px;\n  background: #ffffff;\n  color: #5f7696;\n  font-size: 9px;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n.paid-media-mini-tag--platform {\n  height: 23px;\n  padding: 0 12px;\n  font-size: 10px;\n  color: #0f172a;\n}\n\n/* Meta platform & Google network “channel” colors */\n.paid-media-mini-tag--channel-instagram {\n  background: rgba(168, 85, 247, 0.16);\n  border-color: #a855f7;\n  color: #6b21a8;\n}\n\n.paid-media-mini-tag--channel-facebook {\n  background: rgba(24, 119, 242, 0.14);\n  border-color: #1877f2;\n  color: #0c4a8c;\n}\n\n.paid-media-mini-tag--channel-audience-network {\n  background: rgba(14, 165, 233, 0.14);\n  border-color: #0ea5e9;\n  color: #0369a1;\n}\n\n.paid-media-mini-tag--channel-messenger {\n  background: rgba(0, 132, 255, 0.14);\n  border-color: #0084ff;\n  color: #075985;\n}\n\n.paid-media-mini-tag--channel-threads {\n  background: rgba(15, 23, 42, 0.08);\n  border-color: #334155;\n  color: #0f172a;\n}\n\n.paid-media-mini-tag--channel-default {\n  background: rgba(100, 116, 139, 0.1);\n  border-color: #94a3b8;\n  color: #334155;\n}\n\n/* Google Ads network types */\n.paid-media-mini-tag--channel-g-search {\n  background: rgba(43, 116, 228, 0.14);\n  border-color: #2b74e4;\n  color: #1e3a8a;\n}\n\n.paid-media-mini-tag--channel-g-search-partners {\n  background: rgba(59, 130, 246, 0.12);\n  border-color: #3b82f6;\n  color: #1e40af;\n}\n\n.paid-media-mini-tag--channel-g-pmax {\n  background: rgba(234, 88, 12, 0.12);\n  border-color: #ea580c;\n  color: #9a3412;\n}\n\n.paid-media-mini-tag--channel-g-shopping {\n  background: rgba(22, 163, 74, 0.12);\n  border-color: #16a34a;\n  color: #14532d;\n}\n\n.paid-media-mini-tag--channel-g-discover {\n  background: rgba(217, 70, 239, 0.12);\n  border-color: #d946ef;\n  color: #86198f;\n}\n\n.paid-media-mini-tag--channel-g-gmail {\n  background: rgba(220, 38, 38, 0.1);\n  border-color: #dc2626;\n  color: #991b1b;\n}\n\n.paid-media-mini-tag--channel-g-youtube {\n  background: rgba(239, 68, 68, 0.12);\n  border-color: #ef4444;\n  color: #b91c1c;\n}\n\n.paid-media-mini-tag--channel-g-content {\n  background: rgba(99, 102, 241, 0.12);\n  border-color: #6366f1;\n  color: #3730a3;\n}\n\n.paid-media-mini-tag--channel-g-display {\n  background: rgba(20, 184, 166, 0.12);\n  border-color: #14b8a6;\n  color: #0f766e;\n}\n\n.paid-media-mini-tag--channel-g-smart {\n  background: rgba(245, 158, 11, 0.14);\n  border-color: #f59e0b;\n  color: #b45309;\n}\n\n.paid-media-mini-tag--channel-g-local {\n  background: rgba(37, 99, 235, 0.12);\n  border-color: #2563eb;\n  color: #1e3a8a;\n}\n\n.paid-media-mini-tag--channel-g-app {\n  background: rgba(124, 58, 237, 0.12);\n  border-color: #7c3aed;\n  color: #5b21b6;\n}\n\n.paid-media-mini-tag--channel-g-other {\n  background: rgba(71, 85, 105, 0.1);\n  border-color: #64748b;\n  color: #334155;\n}\n\n/* Campaign vs ad set / ad group row semantics */\n.paid-media-mini-tag--role-campaign {\n  background: rgba(245, 158, 11, 0.16);\n  border-color: #f59e0b;\n  color: #b45309;\n}\n\n.paid-media-mini-tag--role-adset {\n  background: rgba(13, 148, 136, 0.14);\n  border-color: #14b8a6;\n  color: #0f766e;\n}\n\n/* Meta post / creative type */\n.paid-media-mini-tag--meta-post-type {\n  background: rgba(99, 102, 241, 0.12);\n  border-color: #818cf8;\n  color: #4338ca;\n}\n\n.paid-media-inline-badge {\n  display: inline-flex;\n  align-items: center;\n  height: 20px;\n  padding: 0 8px;\n  border: 1px solid #d8e1ec;\n  border-radius: 999px;\n  color: #0f172a;\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: lowercase;\n}\n\n.paid-media-spark-trend {\n  width: 88px;\n  height: 28px;\n}\n\n.paid-media-status-chip--active {\n  background: #2b74e4;\n  border-color: #2b74e4;\n  color: #ffffff;\n}\n\n.paid-media-status-chip--paused,\n.paid-media-status-chip--learning {\n  background: #ffffff;\n  color: #0f172a;\n}\n\n.paid-media-status {\n  display: inline-flex;\n  align-items: center;\n  padding: 4px 10px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: capitalize;\n}\n\n.paid-media-status--active {\n  background: rgba(22, 163, 74, 0.12);\n  color: #15803d;\n}\n\n.paid-media-status--learning {\n  background: rgba(245, 158, 11, 0.12);\n  color: #b45309;\n}\n\n.paid-media-status--paused {\n  background: rgba(100, 116, 139, 0.12);\n  color: #475569;\n}\n\n.paid-media-empty-state {\n  padding: 36px 24px;\n  text-align: center;\n  color: #64748b;\n  font-size: 14px;\n}\n\n.paid-media-meta-charts {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  margin-top: 4px;\n  margin-bottom: 24px;\n}\n\n.paid-media-meta-charts .paid-media-panel--chart-stack {\n  width: 100%;\n  margin-bottom: 0;\n}\n\n.paid-media-chart--roas-stack {\n  height: 250px;\n  min-height: 250px;\n}\n\n.paid-media-meta-charts .paid-media-panel--chart-stack .paid-media-chart--grouped {\n  height: 300px;\n  min-height: 300px;\n}\n\n.paid-media-meta-charts .paid-media-panel--chart-stack .paid-media-chart--post-type {\n  height: 280px;\n  min-height: 280px;\n}\n\n/* Google Ads 2-row chart grid */\n.paid-media-google-charts-row1 {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n.paid-media-google-charts-row2 {\n  display: grid;\n  grid-template-columns: minmax(0, 2fr) minmax(0, 1fr);\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.paid-media-google-charts-row2--stacked {\n  grid-template-columns: 1fr;\n}\n\n.paid-media-google-charts-row1 .paid-media-panel--chart-stack,\n.paid-media-google-charts-row2 .paid-media-panel--chart-stack {\n  width: 100%;\n  margin-bottom: 0;\n}\n\n.paid-media-google-charts-row1 .paid-media-chart--roas-stack,\n.paid-media-google-charts-row1 .paid-media-chart--grouped {\n  height: 260px;\n  min-height: 260px;\n}\n\n.paid-media-google-charts-row2 .paid-media-chart--post-type {\n  height: 280px;\n  min-height: 280px;\n}\n\n.paid-media-google-charts-row2 .paid-media-chart--roas-stack {\n  height: 300px;\n  min-height: 300px;\n}\n\n.paid-media-spend-distribution-body {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.paid-media-spend-distribution-body--wide {\n  display: grid;\n  grid-template-columns: minmax(260px, 320px) minmax(0, 1fr);\n  gap: 16px 24px;\n  align-items: center;\n}\n\n.paid-media-spend-distribution-body--wide .paid-media-chart--roas-stack {\n  height: 300px;\n  min-height: 300px;\n  width: 100%;\n}\n\n.paid-media-pie-legend {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 0 8px 8px;\n  margin-top: 8px;\n}\n\n.paid-media-spend-distribution-body--wide .paid-media-pie-legend {\n  margin-top: 0;\n  padding: 0;\n}\n\n.paid-media-pie-legend--two-columns {\n  display: block;\n  column-count: 2;\n  column-gap: 24px;\n}\n\n.paid-media-pie-legend--two-columns .paid-media-pie-legend__item {\n  break-inside: avoid;\n  margin-bottom: 8px;\n}\n\n.paid-media-pie-legend--two-columns .paid-media-pie-legend__item:last-child {\n  margin-bottom: 0;\n}\n\n.paid-media-pie-legend__item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12px;\n  color: #344054;\n  min-width: 0;\n}\n\n.paid-media-pie-legend__swatch {\n  flex-shrink: 0;\n  width: 10px;\n  height: 10px;\n  border-radius: 2px;\n}\n\n.paid-media-pie-legend__name {\n  flex: 1 1 auto;\n  font-weight: 500;\n  color: #344054;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.paid-media-pie-legend__value {\n  flex-shrink: 0;\n  font-weight: 600;\n  color: #000;\n  white-space: nowrap;\n}\n\n.paid-media-pie-legend__pct {\n  margin-inline-start: 4px;\n  font-weight: 400;\n  color: #60718b;\n}\n\n@media (max-width: 1100px) {\n  .paid-media-google-charts-row1 {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .paid-media-google-charts-row2 {\n    grid-template-columns: 1fr;\n  }\n\n  .paid-media-spend-distribution-body--wide {\n    grid-template-columns: 1fr;\n  }\n\n  .paid-media-pie-legend--two-columns {\n    column-count: 1;\n  }\n}\n\n@media (max-width: 700px) {\n  .paid-media-google-charts-row1 {\n    grid-template-columns: 1fr;\n  }\n}\n\n.paid-media-panel--chart-stack {\n  padding: 18px 18px 14px;\n}\n\n.paid-media-panel--chart-stack .paid-media-panel__header {\n  margin-bottom: 10px;\n}\n\n.paid-media-panel--chart-stack .recharts-responsive-container {\n  overflow: visible;\n}\n\n.paid-media-panel--chart-stack .recharts-cartesian-axis-tick text {\n  font-family: \"opensans\", sans-serif;\n  font-weight: 500;\n}\n\n/**\n * Recharts places ticks, bars and labels with absolute SVG coordinates and `text-anchor`, which\n * resolve against the inline base direction — inheriting `dir=\"rtl\"` flips the anchoring under\n * geometry computed for LTR, so Arabic axis labels overlap their own bars and clip at the panel\n * edge. The surface stays LTR and the layout is mirrored through props instead (see\n * `usePaidMediaChartRtl`). Scoped to the surface: `.recharts-tooltip-wrapper` is a sibling div\n * that must keep the page direction so its Arabic text reads right-to-left.\n */\n.paid-media-chart .recharts-surface {\n  direction: ltr;\n}\n\n.paid-media-table-zone {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n  margin-top: 0;\n  border: 0;\n  border-radius: 0;\n  background: transparent;\n  box-shadow: none;\n  overflow: visible;\n}\n\n.paid-media-tabs-bar--attached {\n  margin-top: 0;\n  margin-bottom: 0;\n  padding: 6px;\n  border: 1px solid #e6edf5;\n  border-radius: 8px;\n  background: #eef2f7;\n  box-shadow: none;\n}\n\n.paid-media-table-panel--attached.dashboard-data-table-panel,\n.paid-media-table-panel--attached {\n  margin-top: 0;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04), 0 4px 12px rgba(15, 23, 42, 0.03);\n  background: #ffffff;\n}\n\n.paid-media-report .dashboard-data-table-panel__header {\n  min-height: 76px;\n  padding: 20px 20px;\n  gap: 16px;\n}\n\n.paid-media-report .dashboard-data-table-panel__header h3 {\n  font-size: 16px;\n  line-height: 1.25;\n}\n\n.paid-media-report .dashboard-data-table-panel__search {\n  min-width: 274px;\n  height: 45px;\n  padding: 0 12px;\n  margin-bottom: 0;\n}\n\n.paid-media-report .dashboard-data-table-panel__search input {\n  font-size: 13px;\n  padding-inline-start: 8px;\n}\n\n.paid-media-report .dashboard-data-table th {\n  padding: 17px 20px;\n  color: #9aa6b5;\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n\n.paid-media-table-panel__heading-block {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 0;\n}\n\n.paid-media-table-panel__subtitle {\n  margin: 0;\n  font-size: 12px;\n  font-weight: 500;\n  color: #64748b;\n}\n\n.paid-media-table__entity-link {\n  color: #2563eb;\n  font-weight: 600;\n  font-size: 13px;\n}\n\n.paid-media-campaign-table-panel.dashboard-data-table-panel {\n  border-color: #e2e8f0;\n  border-radius: 8px;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 2px 8px rgba(15, 23, 42, 0.04);\n}\n\n.paid-media-campaign-table-panel .dashboard-data-table-panel__header {\n  min-height: 84px;\n  padding: 22px 24px;\n  border-bottom: 1px solid #e5eaf1;\n}\n\n.paid-media-campaign-table-panel .paid-media-panel__heading h3 {\n  margin-bottom: 0;\n  color: #344054;\n  font-size: 20px;\n  font-weight: 700;\n  line-height: 1.2;\n}\n\n.paid-media-campaign-table-panel .paid-media-table-toolbar {\n  align-items: center;\n  flex: 0 1 auto;\n  gap: 14px;\n}\n\n.paid-media-campaign-table-panel .paid-media-table-toolbar__search {\n  display: inline-flex;\n  align-items: center;\n  width: 320px;\n  min-width: 320px;\n  height: 45px;\n  margin: 0;\n  border-color: #d6dde8;\n  border-radius: 8px;\n  color: #7a8797;\n}\n\n.paid-media-campaign-table-panel .paid-media-table-toolbar__search input {\n  color: #344054;\n  font-size: 14px;\n}\n\n.paid-media-campaign-table-panel .paid-media-table-toolbar__search input::placeholder {\n  color: #8a96a8;\n}\n\n.paid-media-campaign-table-panel .paid-media-export-btn {\n  align-self: center;\n  height: 45px;\n  margin: 0;\n  padding: 0 16px;\n  border-color: #d6dde8;\n  color: #536174;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.paid-media-campaign-performance-table.dashboard-data-table {\n  min-width: 1120px;\n}\n\n.paid-media-campaign-performance-table.dashboard-data-table thead th {\n  padding: 18px 24px;\n  background: #ffffff;\n  border-bottom: 1px solid #eef2f7;\n  color: #a3adbd;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0;\n  text-transform: uppercase;\n}\n\n.paid-media-campaign-performance-table.dashboard-data-table thead th .dashboard-data-table__sort {\n  text-transform: uppercase;\n}\n\n.paid-media-campaign-performance-table.dashboard-data-table tbody td {\n  height: 72px;\n  padding: 18px 24px;\n  border-top: 1px solid #eef2f7;\n  color: #667085;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.paid-media-campaign-performance-table.dashboard-data-table tbody tr:hover td {\n  background: #ffffff;\n}\n\n.paid-media-campaign-performance-table.dashboard-data-table tbody tr.paid-media-table-subrow td {\n  height: 72px;\n  background-color: #f3f4f6 !important;\n  border-top-color: #eef2f7;\n}\n\n.paid-media-campaign-performance-table.dashboard-data-table tbody tr.paid-media-table-subrow:hover td {\n  background-color: #f3f4f6 !important;\n}\n\n.paid-media-campaign-performance-table .paid-media-campaign-cell {\n  min-width: 238px;\n  gap: 6px;\n}\n\n.paid-media-campaign-performance-table .paid-media-campaign-cell strong {\n  margin-bottom: 3px;\n  color: #536174;\n  font-size: 13px;\n  font-weight: 800;\n}\n\n.paid-media-campaign-performance-table .paid-media-campaign-expand {\n  width: 16px;\n  height: 18px;\n  margin-top: 0;\n  color: #a3adbd;\n}\n\n.paid-media-campaign-performance-table .paid-media-campaign-expand svg {\n  width: 14px;\n  height: 14px;\n  stroke-width: 2.3;\n}\n\n.paid-media-campaign-performance-table .paid-media-mini-tag--muted {\n  margin-top: 0;\n  padding: 3px 8px;\n  border: 1px solid #F3F4F6;\n  border-radius: 4px;\n  background: #F9FAFB;\n  color: #9CA3AF;\n  font-size: 11px;\n  font-weight: 700;\n  line-height: 1;\n}\n\n.paid-media-campaign-performance-table .paid-media-table-subrow__label {\n  display: grid;\n  gap: 3px;\n  padding-inline-start: 38px;\n  color: #536174;\n  font-size: 13px;\n  font-weight: 800;\n}\n\n.paid-media-campaign-performance-table .paid-media-table-subrow__eyebrow {\n  color: #9CA3AF;\n  font-size: 13px;\n  font-weight: 800;\n}\n\n.paid-media-campaign-performance-table td.paid-media-table__metric--success {\n  color: #20bf6b;\n  font-weight: 800;\n}\n\n.paid-media-campaign-table-panel .table-page-pagination {\n  min-height: 64px;\n  padding: 18px 24px;\n  border-top: 1px solid #e5eaf1;\n  background: #ffffff;\n}\n\n.paid-media-campaign-table-panel .table-page-pagination__label {\n  color: #7b8797;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.paid-media-campaign-table-panel .table-page-pagination__btn {\n  width: 32px;\n  height: 32px;\n  border-color: #e0e6ef;\n  border-radius: 7px;\n  background: #ffffff;\n  color: #98a2b3;\n}\n\n.paid-media-adsets-table-panel.dashboard-data-table-panel {\n  border-color: #e2e8f0;\n  border-radius: 8px;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 2px 8px rgba(15, 23, 42, 0.04);\n}\n\n.paid-media-adsets-table-panel .dashboard-data-table-panel__header {\n  min-height: 86px;\n  padding: 22px 24px;\n  border-bottom: 1px solid #e5eaf1;\n}\n\n.paid-media-adsets-table-panel .paid-media-table-panel__heading-block {\n  gap: 8px;\n}\n\n.paid-media-adsets-table-panel .paid-media-panel__heading h3 {\n  margin-bottom: 0;\n  color: #1f2937;\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 1.2;\n}\n\n.paid-media-adsets-table-panel .paid-media-table-panel__subtitle {\n  color: #667085;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.paid-media-adsets-table-panel .paid-media-table-toolbar {\n  align-items: center;\n  flex: 0 1 auto;\n  gap: 14px;\n}\n\n.paid-media-adsets-table-panel .paid-media-table-toolbar__search {\n  display: inline-flex;\n  align-items: center;\n  width: 300px;\n  min-width: 300px;\n  height: 45px;\n  margin: 0;\n  border-color: #d6dde8;\n  border-radius: 8px;\n  color: #7a8797;\n}\n\n.paid-media-adsets-table-panel .paid-media-table-toolbar__search input {\n  color: #344054;\n  font-size: 14px;\n}\n\n.paid-media-adsets-table-panel .paid-media-table-toolbar__search input::placeholder {\n  color: #8a96a8;\n}\n\n.paid-media-adsets-table-panel .paid-media-export-btn {\n  align-self: center;\n  height: 45px;\n  margin: 0;\n  padding: 0 16px;\n  border-color: #d6dde8;\n  color: #536174;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.paid-media-adsets-performance-table.dashboard-data-table {\n  min-width: 1000px;\n}\n\n.paid-media-adsets-performance-table.dashboard-data-table thead th {\n  padding: 18px 24px;\n  background: #ffffff;\n  border-bottom: 1px solid #eef2f7;\n  color: #a3adbd;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0;\n  text-transform: uppercase;\n}\n\n.paid-media-adsets-performance-table.dashboard-data-table thead th .dashboard-data-table__sort {\n  text-transform: uppercase;\n}\n\n.paid-media-adsets-performance-table.dashboard-data-table tbody td {\n  height: 64px;\n  padding: 18px 24px;\n  border-top: 1px solid #eef2f7;\n  color: #344054;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.paid-media-adsets-performance-table.dashboard-data-table tbody tr:hover td {\n  background: #ffffff;\n}\n\n.paid-media-adsets-performance-table .paid-media-table__entity-link {\n  color: #1f2937;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.paid-media-adsets-performance-table td.paid-media-table__metric--success {\n  color: #009e4f;\n  font-weight: 800;\n}\n\n.paid-media-adsets-table-panel .table-page-pagination {\n  min-height: 64px;\n  padding: 18px 24px;\n  border-top: 1px solid #e5eaf1;\n  background: #ffffff;\n}\n\n.paid-media-adsets-table-panel .table-page-pagination__label {\n  color: #7b8797;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.paid-media-adsets-table-panel .table-page-pagination__btn {\n  width: 32px;\n  height: 32px;\n  border-color: #e0e6ef;\n  border-radius: 7px;\n  background: #ffffff;\n  color: #98a2b3;\n}\n\n.paid-media-ads-table-panel.dashboard-data-table-panel {\n  border-color: #e2e8f0;\n  border-radius: 8px;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 2px 8px rgba(15, 23, 42, 0.04);\n}\n\n.paid-media-ads-table-panel .dashboard-data-table-panel__header {\n  min-height: 86px;\n  padding: 22px 24px;\n  border-bottom: 1px solid #e5eaf1;\n}\n\n.paid-media-ads-table-panel .paid-media-table-panel__heading-block {\n  gap: 8px;\n}\n\n.paid-media-ads-table-panel .paid-media-panel__heading h3 {\n  margin-bottom: 0;\n  color: #1f2937;\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 1.2;\n}\n\n.paid-media-ads-table-panel .paid-media-table-panel__subtitle {\n  color: #667085;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.paid-media-ads-table-panel .paid-media-table-toolbar {\n  align-items: center;\n  flex: 0 1 auto;\n  gap: 14px;\n}\n\n.paid-media-table-panel--attached .paid-media-table-toolbar__filters,\n.paid-media-table-panel--attached .paid-media-table-toolbar__filter {\n  min-width: 0;\n}\n\n.paid-media-table-panel--attached .paid-media-table-toolbar__filters .paid-media-filter-dropdown {\n  width: 150px;\n}\n\n.paid-media-table-panel--attached .paid-media-filter-dropdown__trigger {\n  height: 45px;\n  padding-inline-start: 14px;\n  padding-inline-end: 34px;\n  border-color: #d6dde8;\n  border-radius: 8px;\n  color: #344054;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.paid-media-table-panel--attached .paid-media-filter-dropdown__label {\n  color: #344054;\n}\n\n.paid-media-ads-table-panel .paid-media-table-toolbar__search {\n  display: inline-flex;\n  align-items: center;\n  width: 300px;\n  min-width: 300px;\n  height: 45px;\n  margin: 0;\n  border-color: #d6dde8;\n  border-radius: 8px;\n  color: #7a8797;\n}\n\n.paid-media-ads-table-panel .paid-media-table-toolbar__search input {\n  color: #344054;\n  font-size: 14px;\n}\n\n.paid-media-ads-table-panel .paid-media-table-toolbar__search input::placeholder {\n  color: #8a96a8;\n}\n\n.paid-media-ads-table-panel .paid-media-export-btn {\n  align-self: center;\n  height: 45px;\n  margin: 0;\n  padding: 0 16px;\n  border-color: #d6dde8;\n  color: #536174;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.paid-media-ads-performance-table.dashboard-data-table {\n  min-width: 1060px;\n}\n\n.paid-media-ads-performance-table.dashboard-data-table thead th {\n  padding: 18px 24px;\n  background: #ffffff;\n  border-bottom: 1px solid #eef2f7;\n  color: #a3adbd;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0;\n  text-transform: uppercase;\n}\n\n.paid-media-ads-performance-table.dashboard-data-table thead th .dashboard-data-table__sort {\n  text-transform: uppercase;\n}\n\n.paid-media-ads-performance-table.dashboard-data-table tbody td {\n  height: 64px;\n  padding: 18px 24px;\n  border-top: 1px solid #eef2f7;\n  color: #344054;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.paid-media-ads-performance-table.dashboard-data-table tbody tr:hover td {\n  background: #ffffff;\n}\n\n.paid-media-ads-performance-table .paid-media-report__ad-col {\n  min-width: 220px;\n}\n\n.paid-media-ads-performance-table .paid-media-table__entity-link {\n  color: #1f2937;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.paid-media-ads-performance-table .paid-media-mini-tag--platform {\n  height: auto;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: #344054;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.paid-media-ads-performance-table td.paid-media-table__metric--success {\n  color: #009e4f;\n  font-weight: 800;\n}\n\n.paid-media-ads-table-panel .table-page-pagination {\n  min-height: 64px;\n  padding: 18px 24px;\n  border-top: 1px solid #e5eaf1;\n  background: #ffffff;\n}\n\n.paid-media-ads-table-panel .table-page-pagination__label {\n  color: #7b8797;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.paid-media-ads-table-panel .table-page-pagination__btn {\n  width: 32px;\n  height: 32px;\n  border-color: #e0e6ef;\n  border-radius: 7px;\n  background: #ffffff;\n  color: #98a2b3;\n}\n\n.paid-media-export-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  height: 45px;\n  padding: 0 14px;\n  border: 1px solid #d7e0ea;\n  border-radius: 8px;\n  background: #ffffff;\n  color: #0f172a;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  white-space: nowrap;\n  flex-shrink: 0;\n\n  &:hover:not(:disabled) {\n    background: #f8fafc;\n    border-color: #c5d3e3;\n  }\n\n  &:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n  }\n}\n\n.paid-media-tabs-bar {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 6px;\n  margin-bottom: 10px;\n  background: #eef2f7;\n  border-radius: 8px;\n  border: 1px solid #e6edf5;\n  box-shadow: none;\n  margin-top: 20px;\n}\n\n.paid-media-tabs-bar__tab {\n  height: 32px;\n  padding: 0 16px;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  color: #60718b;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.paid-media-tabs-bar__tab--active {\n  background: #ffffff;\n  color: #0f172a;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05);\n}\n\n.paid-media-campaign-cell strong {\n  display: block;\n  margin-bottom: 5px;\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 1.35;\n  text-align: start;\n}\n\n.paid-media-campaign-cell {\n  min-width: 220px;\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n}\n\n.paid-media-campaign-expand {\n  display: inline-flex;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  margin-top: 1px;\n  padding: 0;\n  border: 0;\n  border-radius: 6px;\n  background: transparent;\n  color: #60718b;\n  cursor: pointer;\n  flex-shrink: 0;\n\n  &:hover {\n    background: #eef2f7;\n    color: #1f2937;\n  }\n\n  &--placeholder {\n    display: inline-block;\n    width: 24px;\n    flex-shrink: 0;\n  }\n}\n\n.paid-media-table-subrow {\n  background: transparent;\n\n  td {\n    border-top: 0;\n  }\n}\n\n.paid-media-table-subrow__label {\n  display: inline-block;\n  padding-inline-start: 32px;\n  color: #475569;\n  font-size: 13px;\n}\n\n.paid-media-mini-tag--muted {\n  display: inline-block;\n  margin-top: 4px;\n  color: #64748b;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.paid-media-empty-section {\n  padding: 32px 20px;\n  text-align: center;\n  color: #64748b;\n  font-size: 14px;\n}\n\n.paid-media-tab-grid {\n  display: grid;\n  gap: 16px;\n  margin-bottom: 14px;\n}\n\n.paid-media-tab-grid--two {\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n}\n\n.paid-media-heatmap {\n  display: grid;\n  gap: 12px;\n}\n\n.paid-media-heatmap__header,\n.paid-media-heatmap__row {\n  display: grid;\n  grid-template-columns: 132px repeat(2, minmax(0, 1fr));\n  gap: 18px;\n  align-items: center;\n}\n\n.paid-media-heatmap__header--three-cols,\n.paid-media-heatmap__row--three-cols {\n  grid-template-columns: 132px repeat(3, minmax(0, 1fr));\n}\n\n.paid-media-heatmap__header {\n  color: #52657f;\n  font-size: 12px;\n  font-weight: 500;\n  margin-bottom: 2px;\n}\n\n.paid-media-heatmap__age {\n  color: #475569;\n  font-size: 13px;\n}\n\n.paid-media-heatmap__cell {\n  display: grid;\n    justify-items: center;\n    gap: 6px;\n    min-height: 42px !important;\n    padding: 10px 6px;\n    border-radius: 12px;\n    color: #0f172a;\n}\n\n.paid-media-heatmap__cell strong {\n  font-size: 14px;\n}\n\n.paid-media-heatmap__cell span {\n  font-size: 11px;\n  color: rgba(15, 23, 42, 0.72);\n}\n\n.paid-media-heatmap__legend {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  margin-top: 4px;\n  color: #60718b;\n  font-size: 12px;\n}\n\n.paid-media-heatmap__legend-scale {\n  display: inline-flex;\n  gap: 4px;\n}\n\n.paid-media-heatmap__legend-scale span {\n  width: 34px;\n  height: 10px;\n  border-radius: 999px;\n}\n\n.paid-media-region-cards {\n  display: grid;\n  gap: 10px;\n  margin-bottom: 18px;\n}\n\n.paid-media-region-card {\n  padding: 10px 14px 10px;\n  border-radius: 14px;\n  background: #5bbf8a;\n  color: #ffffff;\n}\n\n.paid-media-region-card__head,\n.paid-media-region-card__meta {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.paid-media-region-card__head {\n  margin-bottom: 6px;\n}\n\n.paid-media-region-card__head strong {\n  font-size: 14px;\n}\n\n.paid-media-region-card__head span {\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.paid-media-region-card__meta {\n  color: rgba(255, 255, 255, 0.84);\n  font-size: 12px;\n  white-space: nowrap;\n}\n\n.paid-media-alerts {\n  display: grid;\n  gap: 14px;\n}\n\n.paid-media-alerts__toolbar {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.paid-media-primary-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  height: 40px;\n  padding: 0 16px;\n  border: 0;\n  border-radius: 12px;\n  background: #2b74e4;\n  color: #ffffff;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.paid-media-panel__title-with-icon {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.paid-media-alert-rules,\n.paid-media-triggered-list,\n.paid-media-recommendations__stack {\n  display: grid;\n  gap: 10px;\n}\n\n.paid-media-alert-rule {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 12px 14px;\n  border-radius: 14px;\n  background: #f8fafc;\n}\n\n.paid-media-alert-rule__left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.paid-media-alert-rule__left strong,\n.paid-media-triggered-item strong,\n.paid-media-recommendation-card strong {\n  display: block;\n  font-size: 13px;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.paid-media-alert-rule__left span,\n.paid-media-triggered-item span,\n.paid-media-recommendation-card span {\n  color: #64748b;\n  font-size: 12px;\n}\n\n.paid-media-switch {\n  position: relative;\n  width: 50px;\n  height: 28px;\n  border: 0;\n  border-radius: 999px;\n  background: #e2e8f0;\n  cursor: pointer;\n}\n\n.paid-media-switch span {\n  position: absolute;\n  top: 3px;\n  inset-inline-start: 3px;\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  background: #ffffff;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.18);\n  transition: transform 0.2s ease;\n}\n\n.paid-media-switch--on {\n  background: #2b74e4;\n}\n\n/* The knob starts at the track's leading edge (`inset-inline-start`) and slides toward the\n   trailing edge, so the travel direction has to flip with the writing direction. */\n.paid-media-switch--on span {\n  transform: translateX(22px);\n}\n\n[dir=\"rtl\"] .paid-media-switch--on span {\n  transform: translateX(-22px);\n}\n\n.paid-media-icon-button {\n  width: 32px;\n  height: 32px;\n  border: 0;\n  border-radius: 10px;\n  background: transparent;\n  color: #64748b;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.paid-media-triggered-list {\n  min-height: 184px;\n  margin-bottom: 18px;\n}\n\n.paid-media-triggered-list__empty {\n  height: 100%;\n  min-height: 184px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #64748b;\n  font-size: 14px;\n}\n\n.paid-media-triggered-item {\n  padding: 12px 14px;\n  border-radius: 14px;\n  border: 1px solid rgba(245, 158, 11, 0.25);\n  background: rgba(245, 158, 11, 0.06);\n}\n\n.paid-media-triggered-item small {\n  display: inline-flex;\n  margin-top: 4px;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.paid-media-alert-value--success {\n  color: #15803d;\n}\n\n.paid-media-alert-value--danger {\n  color: #b91c1c;\n}\n\n.paid-media-recommendations {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 18px;\n}\n\n.paid-media-recommendations__label {\n  margin-bottom: 10px;\n  font-size: 13px;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n\n.paid-media-recommendations__label--positive {\n  color: #16a34a;\n}\n\n.paid-media-recommendations__label--negative {\n  color: #ef4444;\n}\n\n.paid-media-recommendation-card {\n  padding: 14px;\n  border-radius: 14px;\n}\n\n.paid-media-recommendation-card--positive {\n  border: 1px solid rgba(34, 197, 94, 0.25);\n  background: rgba(34, 197, 94, 0.05);\n}\n\n.paid-media-recommendation-card--negative {\n  border: 1px solid rgba(239, 68, 68, 0.22);\n  background: rgba(239, 68, 68, 0.05);\n}\n\n.paid-media-recommendation-card em {\n  font-style: normal;\n  font-weight: 700;\n}\n\n.paid-media-recommendation-card--positive em {\n  color: #15803d;\n}\n\n.paid-media-recommendation-card--negative em {\n  color: #b91c1c;\n}\n\n.google-ads-report__header {\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n  align-items: flex-start;\n  padding: 20px 18px 0;\n}\n\n.google-ads-report__header h2 {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 700;\n}\n\n.google-ads-report__header p {\n  margin: 6px 0 0;\n  color: #64748b;\n  font-size: 14px;\n}\n\n.google-ads-report__filters,\n.google-ads-overview-grid,\n.google-ads-dual-grid,\n.google-ads-table-panel__head,\n.google-ads-pagination,\n.google-ads-report__table-filters {\n  display: flex;\n  gap: 16px;\n}\n\n.google-ads-report__filters,\n.google-ads-report__table-filters {\n  flex-wrap: wrap;\n}\n\n.google-ads-filter-chip select,\n.google-ads-search input {\n  width: 100%;\n  border: 0;\n  outline: none;\n  background: transparent;\n  color: #0f172a;\n  font-size: 13px;\n}\n\n.google-ads-overview-grid,\n.google-ads-dual-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 2fr) minmax(320px, 1fr);\n  margin-bottom: 16px;\n}\n\n.google-ads-chart--large {\n  height: 320px;\n}\n\n.google-ads-chart--medium {\n  height: 260px;\n}\n\n.google-ads-funnel {\n  display: grid;\n  gap: 16px;\n  padding-top: 16px;\n}\n\n.google-ads-funnel__meta,\n.google-ads-table-panel__head,\n.google-ads-pagination {\n  justify-content: space-between;\n  align-items: center;\n}\n\n.google-ads-funnel__bar {\n  height: 16px;\n  border-radius: 999px;\n  background: #e2e8f0;\n  overflow: hidden;\n}\n\n.google-ads-funnel__bar > div {\n  height: 100%;\n  border-radius: inherit;\n}\n\n.google-ads-search {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 240px;\n  height: 40px;\n  padding: 0 12px;\n  border: 1px solid #d7dee8;\n  border-radius: 14px;\n  color: #64748b;\n}\n\n.google-ads-primary-cell {\n  display: grid;\n  gap: 4px;\n}\n\n.google-ads-primary-cell small {\n  color: #64748b;\n}\n\n.google-ads-metric-strong {\n  color: #2b74e4;\n  font-weight: 700;\n}\n\n.google-ads-pagination {\n  padding: 14px 18px 18px;\n  font-size: 13px;\n  color: #64748b;\n}\n\n.google-ads-pagination__actions {\n  display: flex;\n  gap: 8px;\n}\n\n.google-ads-pagination__actions button {\n  width: 32px;\n  height: 32px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid #d7dee8;\n  border-radius: 10px;\n  background: #fff;\n  cursor: pointer;\n}\n\n.google-ads-pagination__actions button:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.google-ads-inner-tabs {\n  display: flex;\n  gap: 8px;\n  padding: 8px;\n  margin: 16px 0;\n}\n\n.google-ads-inner-tabs__button {\n  height: 36px;\n  padding: 0 16px;\n  border: 0;\n  border-radius: 12px;\n  background: transparent;\n  color: #64748b;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.google-ads-inner-tabs__button--active {\n  background: #eff6ff;\n  color: #1d4ed8;\n}\n\n.google-ads-mini-trend {\n  width: 80px;\n  height: 28px;\n  margin: 0 auto;\n}\n\n.google-ads-table-panel--full {\n  grid-column: 1 / -1;\n  min-width: 0;\n}\n\n.google-ads-table-panel--full:has(.paid-media-filter-dropdown--open) {\n  overflow: visible;\n}\n\n.google-ads-table-panel--full .paid-media-filter-dropdown--open {\n  z-index: 40;\n}\n\n.google-ads-table-panel--full .paid-media-filter-dropdown__menu {\n  max-height: min(320px, calc(50vh - 16px));\n  overflow-y: auto;\n}\n\n.google-ads-table-panel--full .paid-media-filter-dropdown--upward .paid-media-filter-dropdown__menu {\n  top: auto;\n  bottom: calc(100% + 8px);\n}\n\n.google-ads-table-panel--full .paid-media-table-toolbar {\n  align-items: center;\n  gap: 12px;\n}\n\n.google-ads-table-panel--full .dashboard-section-header__control {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  min-width: auto;\n}\n\n.google-ads-table-panel--full .paid-media-filter-dropdown__trigger {\n  height: 45px;\n  padding-inline-start: 14px;\n  padding-inline-end: 34px;\n  width: 250px;\n  border-color: #d6dde8;\n  border-radius: 8px;\n  font-size: 14px;\n  color: #344054;\n}\n\n.google-ads-table-panel--full .paid-media-table-toolbar__search {\n  display: inline-flex;\n  align-items: center;\n  height: 45px;\n  margin: 0;\n  width: 250px;\n  border-color: #d6dde8;\n  border-radius: 8px;\n  color: #7a8797;\n}\n\n.google-ads-table-panel--full .paid-media-table-toolbar__search input {\n  color: #344054;\n  font-size: 14px;\n}\n\n.google-ads-table-panel--full .paid-media-table-toolbar__search input::placeholder {\n  color: #8a96a8;\n}\n\n/* Ad Group Performance table: stack tags below the name */\n.google-ads-adgroup-table .paid-media-campaign-cell {\n  flex-direction: column;\n  gap: 4px;\n}\n\n.google-ads-adgroup-table .paid-media-campaign-cell strong {\n  margin-bottom: 0;\n}\n\n.google-ads-adgroup-table .paid-media-tag-row {\n  margin-top: 0;\n}\n\n.google-ads-report .dashboard-data-table thead th,\n.google-ads-report .paid-media-table thead th {\n  text-transform: uppercase;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.02em;\n  color: #a3adbd;\n}\n\n.google-ads-report .dashboard-data-table thead th .dashboard-data-table__sort,\n.google-ads-report .paid-media-table thead th .paid-media-table__sort {\n  text-transform: uppercase;\n}\n\n.google-ads-report .paid-media-mini-tag--muted {\n  margin-top: 0;\n  padding: 3px 8px;\n  border: 1px solid #f3f4f6;\n  border-radius: 4px;\n  background: #f9fafb;\n  color: #9ca3af;\n  font-size: 11px;\n  font-weight: 700;\n  line-height: 1;\n}\n\n\n.google-ads-report .dashboard-data-table thead th.dashboard-data-table__number,\n.google-ads-report .paid-media-table thead th.paid-media-table__number,\n.google-ads-report .dashboard-data-table thead th.dashboard-data-table__number .dashboard-data-table__sort,\n.google-ads-report .paid-media-table thead th.paid-media-table__number .paid-media-table__sort {\n  text-align: start !important;\n  justify-content: flex-start;\n}\n\n.google-ads-trend-cell {\n  text-align: center;\n}\n\n.google-ads-heatmap {\n  overflow-x: auto;\n}\n\n.google-ads-heatmap__table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.google-ads-heatmap__table th,\n.google-ads-heatmap__table td {\n  padding: 10px;\n  text-align: start;\n}\n\n.google-ads-heatmap__chip {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 72px;\n  padding: 10px 12px;\n  border-radius: 12px;\n  background: rgba(43, 116, 228, 0.12);\n  color: #2b74e4;\n  font-weight: 700;\n}\n\n.google-ads-alerts {\n  display: grid;\n  gap: 14px;\n}\n\n.google-ads-alert-card {\n  display: grid;\n  grid-template-columns: 40px minmax(0, 1fr);\n  gap: 14px;\n  padding: 18px;\n  border: 1px solid #e2e8f0;\n  border-radius: 16px;\n  background: #fff;\n}\n\n.google-ads-alert-card__icon {\n  width: 40px;\n  height: 40px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 12px;\n  background: #eff6ff;\n  color: #1d4ed8;\n}\n\n.google-ads-alert-card h3 {\n  margin: 0 0 6px;\n  font-size: 15px;\n}\n\n.google-ads-alert-card p {\n  margin: 0;\n  color: #64748b;\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n@media (max-width: 1400px) {\n  .paid-media-kpi-grid {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 1100px) {\n  .paid-media-overview-grid,\n  .paid-media-campaigns-grid,\n  .paid-media-meta-charts .paid-media-chart--roas-stack,\n  .paid-media-meta-charts .paid-media-chart--grouped,\n  .paid-media-meta-charts .paid-media-chart--post-type,\n  .paid-media-tab-grid--two,\n  .paid-media-recommendations,\n  .paid-media-kpi-grid,\n  .google-ads-overview-grid,\n  .google-ads-dual-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .paid-media-panel__header,\n  .paid-media-table-panel__header,\n  .dashboard-data-table-panel__header,\n  .google-ads-report__header,\n  .google-ads-table-panel__head,\n  .google-ads-pagination {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .paid-media-table-panel__search,\n  .dashboard-data-table-panel__search {\n    min-width: 100%;\n  }\n\n  .paid-media-panel__header-actions--trend {\n    align-items: flex-end;\n    margin-inline-start: 0;\n    min-width: 0;\n    width: 100%;\n  }\n\n  .paid-media-trend-granularity {\n    align-self: flex-end;\n  }\n\n  .paid-media-trend-chips {\n    justify-content: flex-end;\n  }\n\n  .paid-media-trend-pagination {\n    width: 100%;\n  }\n\n  .paid-media-heatmap__header,\n  .paid-media-heatmap__row {\n    grid-template-columns: 90px repeat(2, minmax(0, 1fr));\n    gap: 10px;\n  }\n\n  .paid-media-heatmap__header--three-cols,\n  .paid-media-heatmap__row--three-cols {\n    grid-template-columns: 90px repeat(3, minmax(0, 1fr));\n  }\n\n  .paid-media-region-card__head,\n  .paid-media-region-card__meta {\n    flex-wrap: wrap;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
